class HttpStatus {
}

HttpStatus.SUCCESS = 200
HttpStatus.BAD_REQUEST = 400
HttpStatus.UNAUTHORIZED = 401
HttpStatus.FORBIDDEN = 403
HttpStatus.NOT_FOUND = 404
HttpStatus.INTERNAL_SERVER_ERROR = 500

class ContentType {
}

ContentType.URL_ENCODED = 'application/x-www-form-urlencoded'
ContentType.JSON = 'application/json'
ContentType.FORM_DATA = 'multipart/form-data'
ContentType.HTML = 'text/html'
ContentType.PDF = 'application/pdf'

class ResponseType {
}

ResponseType.BLOB = 'blob'
const NORSE_FILTERS = {
    FILTER: 'filter',
    ORDER: 'order',
    QUERY: 'query',
    PAGE: 'page',
    TAB: 'tab',
    FROM: 'from',
    TO: 'to',
    DATE: 'date',
    PAGE_CONTROLLER: 'pc',
    CHECKLIST: 'checklist',
    CUSTOM: 'custom',
}

class Constants {
}

Constants.WEEKDAYS_DEFAULT = [1, 2, 3, 4, 5, 6, 0]
Constants.STATE_COLOR_MAP = {
    1: 'secondary',
    2: 'warning',
    3: 'info',
    4: 'success',
    5: 'error',
}

class StatusCodes {
}

StatusCodes.HTTP_200_OK = 200
StatusCodes.HTTP_201_CREATED = 201
StatusCodes.HTTP_202_ACCEPTED = 202
StatusCodes.HTTP_403_FORBIDDEN = 403
StatusCodes.HTTP_408_REQUEST_TIMEOUT = 408
StatusCodes.HTTP_500_INTERNAL_SERVER_ERROR = 500


Constants.Map = {
    MARKER_ACTIVE_ICON_NON_EXISTING: '/static/img/map_images/marker_icon_active_non_existing.png',
    MARKER_ACTIVE_ICON_NON_EXISTING_REMOVE: '/static/img/map_images/marker_icon_active_non_existing_remove.png',
    MARKER_ACTIVE_ICON_EXISTING: '/static/img/map_images/marker_icon_active.png',
    MARKER_IO_ICON: '/static/img/map_images/io_facility_2.svg',
    MARKER_IO_MAIN_ICON: '/static/img/map_images/io_facility_main_2.svg',
    MARKER_INACTIVE_ICON: '/static/img/map_images/facility_marker.png',
    MARKER_USER_ICON: '/static/img/map_images/marker_icon_user.png',
    MARKER_CONNECTED_BUILDING_ICON: '/static/img/map_images/marker_icon_connected_to_building.png',
    MARKER_CLUSTER_ICON: '/static/img/map_images/clusters/m',
    DEFAULT_CENTER: {lng: 15.62, lat: 56.2},
    DEFAULT_ZOOM: 10,
    SELECTED_MARKER_ZOOM: 18,
    MARKER_CLUSTER_STYLE_M1: {
        textColor: '#323e4b',
        fontWeight: 'bold',
        textSize: 16,
        url: `/static/img/map_images/clusters/m1.png`,
        height: 35,
        width: 35,
        anchorText: [8, 0]
    },
    MARKER_CLUSTER_STYLE_M2: {
        textColor: '#323e4b',
        fontWeight: 'bold',
        textSize: 16,
        url: `/static/img/map_images/clusters/m2.png`,
        height: 40,
        width: 40,
        anchorText: [12, 0]
    },
    MARKER_CLUSTER_STYLE_M3: {
        textColor: '#323e4b',
        fontWeight: 'bold',
        textSize: 16,
        url: `/static/img/map_images/clusters/m3.png`,
        height: 50,
        width: 50,
        anchorText: [16, 0]
    },
    MARKER_CLUSTER_STYLE_M4: {
        textColor: '#3c5064',
        fontWeight: 'bold',
        textSize: 16,
        url: `/static/img/map_images/clusters/m4.png`,
        height: 50,
        width: 50,
        anchorText: [15, 0]
    }
}

const BACK_END_ERROR_MESSAGE = 'message'

class Action {
    constructor(actionID, url = '') {
        this.actionID = actionID
        this.client = new NorseClient(url)

        this.form = new FormAction(actionID, this.client)
        this.template = new TemplateAction(actionID, this.client)
        this.modal = new ModalAction(actionID, this.client)
        this.download = new Downloader(actionID, this.client)
    }

    performAction(data = {}, config) {
        let norseData = this.client.getNorseData(data, this.actionID)
        return this.client.post(norseData, config)
    }

    dispatchStartAction(app) {
        app.loader.dispatchStartLoading(this.actionID)
        return this
    }

    //Useful for manual catching of errors
    dispatchStopAction(app) {
        app.loader.dispatchStopLoading(this.actionID)
    }

    dispatchClearAction(app) {
        app.loader.dispatchStopLoading('')
        return this
    }

    setErrorHandler(errorHandler) {
        this.client.setErrorHandler(errorHandler)
    }

    enableManualCatch() {
        this.client.enableManualCatch()
        return this
    }
}

class FormAction {
    static errorsKey = 'errors'
    // Set by n-visit-notice-prompt: takes the visits a change would move
    // or remove and resolves with the user's answer, or null to cancel.
    static visitNoticePrompt = null
    redirectUrlKey = 'redirect_url'
    messageKey = 'message'
    visitNoticesConfirmKey = 'visit_notices_confirm'
    visitNoticesKey = 'visit_notices'
    facilitiesWithoutEmailKey = 'visit_notice_facilities_without_email'
    visitNoticeAnswerKey = 'visit_notice_answer'
    visitNoticesFailedKey = 'visit_notices_failed_message'
    // Set on the response when the user cancelled the change in the
    // prompt, so a form can show its saved values again.
    static visitNoticesCancelledKey = 'visit_notices_cancelled'

    constructor(actionID, client) {
        this.actionID = actionID
        this.client = client
        this.showToast = true
        this.canRedirect = true
    }

    setErrorHandler(errorHandler) {
        this.client.setErrorHandler(errorHandler)
    }

    setGenericErrorHandler(app) {
        this.client.setErrorHandler((error) => {
            this.handleErrors(error, app)
        })
    }

    handleErrors(error, app) {
        app.loader.dispatchStopLoading(this.actionID)
        let errors = error.response.data[FormAction.errorsKey]
        FormAction.updateErrors(this.formId, errors, app)

        if (this.showToast) {
            let message = error.response.data[BACK_END_ERROR_MESSAGE]
            this._handleMessageErrors(message, app)
            this._handleNonFieldError(errors, app)
        }
    }

    _handleMessageErrors(message, app) {
        if (message) {
            app.toaster.addMessage(message, 'error')
        }
    }

    _handleNonFieldError(errors, app) {
        if (!errors) return

        let nonField = errors['__all__']
        if (nonField) {
            app.toaster.addMessage(nonField, 'error')
        }
    }

    disableToast() {
        this.showToast = false
    }

    disableRedirect() {
        this.canRedirect = false
    }

    /**
     *  Pass the element's id to extract the data from the HTML and post it.
     * */
    post_element(app, elementId = NorseForm.DEFAULT_FORM_ID) {
        let form = new NorseForm(elementId)
        return this.post(form, app, elementId)
    }

    post(data = {}, app, formId = NorseForm.DEFAULT_FORM_ID) {
        this.formId = formId

        // This allows the programmer to  define their own error handler outside
        this.client.setToaster(app.toaster)
        if (this.client.hasGenericErrorHandler()) {
            this.setGenericErrorHandler(app)
        }

        if (data instanceof NorseForm) {
            data = data.getData()
        }

        let norseData = this.client.getNorseData(data, this.actionID)
        return this.client.post(norseData).then((response) => {
            return this._confirmVisitNotices(norseData, response, app)
        }).then((response) => {
            return new Promise((outerResolve) => {
                FormAction.updateErrors(this.formId, [], app)
                if (response.data) {
                    const {redirect_url} = response.data
                    if (this.canRedirect
                        && redirect_url) {
                        window.location = response.data[this.redirectUrlKey]
                        return outerResolve(response)
                    }
                    if (this.messageKey in response.data) {
                        app.toaster.addMessage(response.data[this.messageKey], 'success')
                    }
                    if (this.visitNoticesFailedKey in response.data) {
                        app.toaster.addMessage(response.data[this.visitNoticesFailedKey], 'error')
                    }
                }
                app.loader.dispatchStopLoading(this.actionID)
                return outerResolve(response)
            })
        })
    }

    // The server saved nothing yet: the change would move or remove
    // visits facilities were emailed about. The answer posts the change
    // again; cancelling resolves a response flagged
    // visit_notices_cancelled, so the caller can show the unchanged state.
    _confirmVisitNotices(norseData, response, app) {
        if (!response.data?.[this.visitNoticesConfirmKey]) {
            return Promise.resolve(response)
        }
        const cancelled = {data: {[FormAction.visitNoticesCancelledKey]: true}}
        if (!FormAction.visitNoticePrompt) {
            app.toaster.addMessage(gettext('The change was not saved. Reload the page and try again.'), 'error')
            return Promise.resolve(cancelled)
        }
        const visitNotices = response.data[this.visitNoticesKey]
        const facilitiesWithoutEmail = response.data[this.facilitiesWithoutEmailKey] || []
        return FormAction.visitNoticePrompt(visitNotices, facilitiesWithoutEmail).then((answer) => {
            if (!answer) return cancelled
            norseData.addData(this.visitNoticeAnswerKey, JSON.stringify(answer))
            return this.client.post(norseData)
        })
    }

    static updateErrors(formId, errors, app) {
        let newErrors = {}
        newErrors[formId] = errors
        app.errors = newErrors
    }
}

class TemplateAction {
    constructor(actionID, client) {
        this.actionID = actionID
        this.client = client
    }

    setErrorHandler(errorHandler) {
        this.client.setErrorHandler(errorHandler)
    }

    setGenericErrorHandler(app) {
        this.client.setErrorHandler((error) => {
            this.handleErrors(error, app)
        })
    }

    handleErrors(error, app) {
        app.loader.dispatchStopLoading(this.actionID)
        let message = error.response.data[BACK_END_ERROR_MESSAGE]
        if (message) {
            app.toaster.addMessage(message, 'error')
        }
    }

    load(templateId, app, data = {}) {
        this.client.setToaster(app.toaster)
        if (this.client.hasGenericErrorHandler()) {
            this.setGenericErrorHandler(app)
        }

        if (data instanceof NorseForm) {
            data = data.getData()
        }

        let norseData = this.client.getNorseData(data, this.actionID)
        return this.client.post(norseData).then((response) => {
            return new Promise((outerResolve) => {
                this._addNewTemplate(templateId, response.data, app)
                app.loader.dispatchStopLoading(this.actionID)
                return outerResolve(response)
            })
        })
    }

    _addNewTemplate(templateId, template, app) {
        let newTemplates = {}
        if (Object.keys(app.templates).includes(templateId)) {
            delete app.templates[templateId]
        }

        newTemplates[templateId] = template
        newTemplates = mergeTwoDicts(newTemplates, app.templates)
        app.templates = newTemplates
    }
}

class MODAL_STATE {
}

MODAL_STATE.OPEN = 'OPEN'
MODAL_STATE.CLOSED = 'CLOSED'

class ModalAction {
    constructor(actionID, client) {
        this.actionID = actionID
        this.client = client
    }

    setErrorHandler(errorHandler) {
        this.client.setErrorHandler(errorHandler)
    }

    setGenericErrorHandler(app) {
        this.client.setErrorHandler((error) => {
            this.handleErrors(error, app)
        })
    }

    handleErrors(error, app) {
        app.loader.dispatchStopLoading(this.actionID)
        let message = error.response.data[BACK_END_ERROR_MESSAGE]
        if (!message) {
            ErrorHandler.processUnexpectedError(app.toaster, error)
            return
        }

        app.toaster.addMessage(message, 'error')
    }

    open(modalId, app, data = {}) {
        this.client.setToaster(app.toaster)
        if (this.client.hasGenericErrorHandler()) {
            this.setGenericErrorHandler(app)
        }

        if (data instanceof NorseForm) {
            data = data.getData()
        }

        let norseData = this.client.getNorseData(data, this.actionID)
        return this.client.post(norseData).then((response) => {
            return new Promise((outerResolve) => {
                this._addNewModal(modalId, response.data, app)
                return outerResolve(response)
            })
        })
    }

    load(modalId, app, data = {}) {
        this.client.setToaster(app.toaster)
        if (this.client.hasGenericErrorHandler()) {
            this.setGenericErrorHandler(app)
        }

        if (data instanceof NorseForm) {
            data = data.getData()
        }

        let norseData = this.client.getNorseData(data, this.actionID)
        return this.client.post(norseData).then((response) => {
            return new Promise((outerResolve) => {

                this._addNewModal(modalId, response.data, app)
                return outerResolve(response)
            })
        })
    }

    _addNewModal(modalId, template, app) {
        // Do the following way in order to trigger the watcher
        // in the template component
        let newModals = {}
        newModals[modalId] = {template: template, state: MODAL_STATE.OPEN}
        newModals = mergeTwoDicts(app.modals, newModals)
        app.modals = newModals
    }
}

class Downloader {
    constructor(actionID, client) {
        this.actionID = actionID
        this.client = client
    }

    pdf(data = {}, app) {
        let contentType = ContentType.PDF

        let norseData = this.client.getNorseData(data.getData(), this.actionID)
        let config = new NorseClient().formConfig
        config['responseType'] = ResponseType.BLOB
        return this.client.post(norseData, config).then((response) => {
            return new Promise((outerResolve) => {
                const report = new Blob([response.data], {type: contentType})
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(report)
                const regExpFilename = /filename="(?<filename>.+)\.(.+)"/
                const filename = regExpFilename.exec(response.headers['content-disposition'])?.groups?.filename ?? null
                link.download = filename || 'report'
                link.click()
                window.URL.revokeObjectURL(link.href)
                return outerResolve(response)
            })
        })
    }

    xls(data = {}, app) {
        let contentType = ContentType.XLS

        let norseData = this.client.getNorseData(data, this.actionID)
        let config = new NorseClient().formConfig
        config['responseType'] = ResponseType.BLOB
        return this.client.post(norseData, config).then((response) => {
            return new Promise((outerResolve) => {
                const report = new Blob([response.data], {type: contentType})
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(report)
                const regExpFilename = /filename="(?<filename>.+)"/
                const filename = regExpFilename.exec(response.headers['content-disposition'])?.groups?.filename ?? null
                link.download = filename || 'report'
                link.click()
                window.URL.revokeObjectURL(link.href)
                return outerResolve(response)
            })
        })
    }
}


/**
 * mapbox-client-filter.js
 * ────────────────────────────────────────────────────────────
 * Generic client-side filter for any "GeoJSON FeatureCollection
 * cached on the page" map view. Loaded as a classic <script>
 * from private_base.html alongside the other shared classes
 * (norse-actions, map-marker, …) so any page controller can
 * use `MapboxClientFilter` as a global.
 *
 * Why this exists
 * ───────────────
 * On the route management view we used to refetch the entire
 * geojson payload every time a planner changed a filter input.
 * For a few hundred routes with simplified line geometry, that
 * round-trip — DB aggregate + ST_Simplify per row + JSON encode
 * + network — takes longer than the filter feels like it should.
 *
 * The pattern instead is:
 *   1. Fetch the full feature set ONCE (no filter) when entering
 *      map view.
 *   2. The page's filter inputs continue to drive the param-builder
 *      (URL stays in sync, table refetch still happens).
 *   3. On filter input change, this class reads the same params
 *      the backend would have, runs them through a set of
 *      JS predicates against the cached features, and reports
 *      the matching IDs back to the caller — which then calls
 *      `setSelectedRouteIds` (or any equivalent) on the map's
 *      route layer to show only those.
 *
 * Reusing on another view
 * ───────────────────────
 * Three things are view-specific:
 *   • The param-builder ID (the table's id, e.g. ID_TABLE_ROUTES)
 *   • The predicates dict — { paramKey: (feature, value) => bool }
 *   • The id property on the feature (default 'route_id')
 *
 * Everything else (param parsing, predicate dispatch, change
 * notification) is shared. The route-management-flavoured predicate
 * set lives in route-filter-predicates.js as ROUTE_FILTER_PREDICATES.
 *
 * Usage example
 * ─────────────
 *   const clientFilter = new MapboxClientFilter({
 *       paramBuilderId: ID_TABLE_ROUTES,
 *       predicates: ROUTE_FILTER_PREDICATES,
 *       getFeatures: () => this.mapRoutes,
 *       onChange: (ids) => this.$refs.rmMap.setVisibleRouteIds(ids),
 *   });
 *   // After data lands, or on filter change:
 *   clientFilter.apply();
 */

class MapboxClientFilter {
    /**
     * @param {Object} opts
     * @param {string} opts.paramBuilderId
     *   The id under which the page's param-builder is registered
     *   (`pHandler.getOrRegisterParamBuilder(id)`). Same id used
     *   by the table flow, so the URL <-> filter <-> map plumbing
     *   stays in one place.
     * @param {Object<string, (feature: Object, value: *) => boolean>} opts.predicates
     *   Keyed by the param name as it appears in the param-builder's
     *   browser params dict. Each predicate receives the GeoJSON
     *   feature and the current value for its key, and returns true
     *   if the feature passes that filter. Predicates only run when
     *   their value is truthy — empty strings, null, and empty
     *   arrays are treated as "no filter for this key".
     * @param {() => Array<Object>} opts.getFeatures
     *   Returns the cached array of GeoJSON features (typically a
     *   reactive Vue data property). Re-evaluated on every apply()
     *   so the latest-loaded set is used.
     * @param {(ids: Array<number>) => void} opts.onChange
     *   Called every apply() with the array of route IDs that pass
     *   the filter. Caller forwards this to the map (e.g.
     *   `mapComponent.setVisibleRouteIds(ids)`).
     * @param {string} [opts.idProperty='route_id']
     *   Property on `feature.properties` that holds the unique id
     *   used by the map layer's selection filter.
     */
    constructor(opts) {
        if (!opts || !opts.paramBuilderId) {
            throw new Error('[MapboxClientFilter] paramBuilderId is required');
        }
        if (typeof opts.getFeatures !== 'function') {
            throw new Error('[MapboxClientFilter] getFeatures(callback) is required');
        }
        if (typeof opts.onChange !== 'function') {
            throw new Error('[MapboxClientFilter] onChange(callback) is required');
        }
        this.paramBuilderId = opts.paramBuilderId;
        this.predicates = opts.predicates || {};
        this.getFeatures = opts.getFeatures;
        this.onChange = opts.onChange;
        this.idProperty = opts.idProperty || 'route_id';
    }

    /**
     * Read current filter params from the page's param-builder, run
     * each value through its predicate against every cached feature,
     * and notify the caller with the matching IDs + an "active" flag.
     *
     * Safe to call before the feature cache has been populated —
     * the result is just an empty list, and the caller's
     * `onChange([], { active: false })` will hide everything until
     * data lands.
     *
     * The `active` flag tells the caller whether ANY predicate had
     * a non-empty value. That lets the page distinguish between
     * "every row matched because no filter is on" (active=false,
     * legend should show every route) vs "every row matched because
     * the filter happens to fit the whole dataset" (active=true,
     * legend should still narrow to those rows).
     */
    apply() {
        const params = this._readParams();
        const features = this.getFeatures() || [];
        const matchingIds = [];

        // "Active" iff at least one predicate's value is non-empty.
        let active = false;
        for (const key of Object.keys(this.predicates)) {
            if (!this._isEmpty(params[key])) {
                active = true;
                break;
            }
        }

        for (const feature of features) {
            if (!this._featureMatches(feature, params)) continue;
            const id = Number(feature?.properties?.[this.idProperty]);
            if (Number.isFinite(id)) matchingIds.push(id);
        }

        this.onChange(matchingIds, { active });
    }

    /** Read the URL-bound params dict from the shared param-builder. */
    _readParams() {
        // pHandler is registered globally by classes.js. If the page
        // hasn't initialised it yet we treat that as "no filters
        // active" rather than crashing — same effect as a fresh
        // browser load.
        if (typeof pHandler === 'undefined') return {};
        try {
            const builder = pHandler.getOrRegisterParamBuilder(this.paramBuilderId);
            return builder.getBrowserParamsDict() || {};
        } catch (_) {
            return {};
        }
    }

    /**
     * True iff every predicate with a non-empty value returns true
     * for the given feature. Predicates whose value is falsy/empty
     * are skipped — they're not asking us to filter on that key.
     */
    _featureMatches(feature, params) {
        for (const key of Object.keys(this.predicates)) {
            const value = params[key];
            if (this._isEmpty(value)) continue;
            const predicate = this.predicates[key];
            if (typeof predicate !== 'function') continue;
            if (!predicate(feature, value)) return false;
        }
        return true;
    }

    /**
     * What "no filter" looks like across the inputs we typically see:
     *   • undefined / null
     *   • empty string
     *   • empty array
     *   • multi-select that emitted [''] (some n-multi-select
     *     wrappers do this when fully cleared)
     */
    _isEmpty(value) {
        if (value == null) return true;
        if (value === '') return true;
        if (Array.isArray(value)) {
            return value.length === 0
                || value.every(v => v == null || v === '');
        }
        return false;
    }
}

/**
 * route-filter-predicates.js
 * ────────────────────────────────────────────────────────────
 * Client-side predicates that mirror what `RoutesFilterSet`
 * (profile_inspector/filters.py) does on the server. Used by
 * MapboxClientFilter on the route management map so changing a
 * filter input doesn't refetch the geojson payload.
 *
 * Loaded as a classic <script> from private_base.html alongside
 * mapbox-client-filter.js so the route-management page controller
 * can read `ROUTE_FILTER_PREDICATES` as a global.
 *
 * The predicate keys must match the param-builder keys the page
 * inputs write to (after the param-builder strips its table-id
 * prefix from URL params):
 *
 *   • query                   — free-text, name__icontains. The
 *                               search input writes to URL param
 *                               `<table_id>_query` via
 *                               n-text-input → setQueryParam();
 *                               this matches NORSE_FILTERS.QUERY.
 *   • inspectors              — multi-select of ProfileInspector ids
 *   • regions                 — multi-select of Region ids (a route
 *                               passes if any of its stops sits in
 *                               any of the selected regions; matches
 *                               the server-side join through
 *                               waypoints → facility → region)
 *   • planned_date_from/to    — DD-MM-YYYY range
 *
 * The matching feature properties are emitted by
 * GeoRoutePropertySerializer (sleipner_route/serializers.py):
 *
 *   feature.properties.name
 *   feature.properties.inspector_ids       — Array<number>
 *   feature.properties.latest_planned_date — formatted DD-MM-YYYY
 *
 * Reusing on another view: pass this dict to MapboxClientFilter.
 * If a view exposes a different filter UI (e.g. create-route v2's
 * filterbar vs route management's toolbar), the predicates that
 * apply are simply the subset whose keys appear in that view's
 * param-builder — predicates with no matching value are no-ops.
 *
 * Wrapped in an IIFE so the date-parsing helpers stay private
 * instead of leaking to the global scope along with the const.
 */
const ROUTE_FILTER_PREDICATES = (() => {
    /**
     * Parse Sleipner's DATE_FORMAT (DD-MM-YYYY) into a UTC timestamp.
     * Returns NaN for malformed input so range checks fail-closed
     * (i.e. the row stays out of the filter).
     *
     * Why parse instead of comparing strings: DD-MM-YYYY isn't
     * lexicographically sortable, so `'01-12-2026' >= '02-01-2026'`
     * gives the wrong answer. Going through Date.UTC sidesteps that.
     */
    function parseSleipnerDate(value) {
        if (!value) return NaN;
        const parts = String(value).split('-');
        if (parts.length !== 3) return NaN;
        const [dd, mm, yyyy] = parts.map(Number);
        if (!Number.isFinite(dd) || !Number.isFinite(mm) || !Number.isFinite(yyyy)) {
            return NaN;
        }
        // Month is 0-indexed in JS Date.
        return Date.UTC(yyyy, mm - 1, dd);
    }

    /** True if `featureValue` is a valid date >= `boundValue`. */
    function dateGte(featureValue, boundValue) {
        const a = parseSleipnerDate(featureValue);
        const b = parseSleipnerDate(boundValue);
        if (Number.isNaN(a) || Number.isNaN(b)) return false;
        return a >= b;
    }

    /** True if `featureValue` is a valid date <= `boundValue`. */
    function dateLte(featureValue, boundValue) {
        const a = parseSleipnerDate(featureValue);
        const b = parseSleipnerDate(boundValue);
        if (Number.isNaN(a) || Number.isNaN(b)) return false;
        return a <= b;
    }

    return {
        // Free-text search — ordered-terms match against route name.
        // Mirrors RouteOrderSearchFieldsMixin's
        // `search_fields = ('name',)` + apply_search's
        // build_search_query (iregex, terms in order).
        // Key is `query` (not `search`) because the n-text-input
        // component writes to URL via setQueryParam() →
        // NORSE_FILTERS.QUERY = 'query'. The param-builder's
        // getBrowserParamsDict strips the table-id prefix, leaving
        // `query` as the dict key on this side.
        query: (feature, value) => {
            return matchesOrderedSearchTerms(feature?.properties?.name, value);
        },

        // Inspector multi-select. Server side uses
        // `work_orders__inspectors__in=value` — i.e. a route passes if
        // ANY of its work_orders' inspectors is in the selected set.
        // ArrayAgg on the backend ships the deduped list of inspector
        // IDs per route, so the client check is set-intersection.
        inspectors: (feature, value) => {
            const selected = Array.isArray(value) ? value : [value];
            const wanted = new Set(
                selected
                    .map(v => Number(v))
                    .filter(n => Number.isFinite(n)),
            );
            if (!wanted.size) return true;
            const have = feature?.properties?.inspector_ids || [];
            for (const id of have) {
                if (wanted.has(Number(id))) return true;
            }
            return false;
        },

        // Region multi-select. Mirrors RoutesFilterSet.filter_regions
        // (server side: `waypoints__facility__region__in=value`).
        // ArrayAgg ships the deduped list of region IDs per route via
        // `region_ids`. A route passes if any of its stops is in any
        // of the selected regions — set-intersection, same shape as
        // `inspectors` above.
        regions: (feature, value) => {
            const selected = Array.isArray(value) ? value : [value];
            const wanted = new Set(
                selected
                    .map(v => Number(v))
                    .filter(n => Number.isFinite(n)),
            );
            if (!wanted.size) return true;
            const have = feature?.properties?.region_ids || [];
            for (const id of have) {
                if (wanted.has(Number(id))) return true;
            }
            return false;
        },

        // Planned-date range. Compares against the latest WO's
        // start_date — same value the server filter uses.
        planned_date_from: (feature, value) =>
            dateGte(feature?.properties?.latest_planned_date, value),
        planned_date_to: (feature, value) =>
            dateLte(feature?.properties?.latest_planned_date, value),
    };
})();

class NorseResponseTools {
    constructor(response) {
        this.response = response
    }

    getContentTypes() {
        return this.response.headers['content-type'] || []
    }

    isJSON() {
        return this.getContentTypes().includes(ContentType.JSON)
    }

    isHTML() {
        return this.getContentTypes().includes(ContentType.HTML)
    }

}

// Enhance axios response with custom functions under norseTools
axios.interceptors.response.use(response => {
        response.norseTools = new NorseResponseTools(response)
        return response
    }, error => {
        const response = error.response
        if (!!response) {
            response.norseTools = new NorseResponseTools(response)
        }

        throw error
    }
)

class NorseClientData {
    constructor(data) {
        this._checkType(data)
        this.data = data
        this._addedData = []
    }

    _checkType(data) {
        if (this._isHtmlFormElement(data) || this._isObject(data)) {
            return
        }
        throw TypeError('HTMLFormElement or Plain json is allowed')
    }


    addData(key, value) {
        this._addedData.push({[key]: value})
    }

    setData(key, value) {
        this.data[key] = value
    }

    getFormData() {
        if (this._isHtmlFormElement(this.data)) {
            let formData = new FormData(this.data)
            let url = this.data.getAttribute('action')
            if (url) {
                formData.append('action_url', url)
            }
            return this._mergeData(formData, this._addedData)
        }

        if (this._isObject(this.data)) {
            let formData = new FormData()
            for (const key in this.data) {
                if (this._isArray(this.data[key])) {
                    this._addArray(formData, key, this.data[key])
                    continue
                }
                formData.append(key, this.data[key])
            }
            return this._mergeData(formData, this._addedData)
        }

    }

    getDataAsDict() {
        let dataObject = this.data
        this._addedData.forEach(obj => {
            dataObject = Object.assign(dataObject, obj)
        })
        return dataObject
    }

    static getNorseClientData(data) {
        if (data instanceof NorseClientData) {
            return data
        }
        return new NorseClientData(data)
    }

    _addArray(formData, key, data) {
        data.forEach(value => {
            formData.append(key, value)
        })
    }

    _mergeData(formData, added_data) {
        added_data.forEach(data => {
            Object.keys(data).forEach(key => {
                formData.append(key, data[key])
            })
        })
        return formData
    }

    _isHtmlFormElement(data) {
        return data instanceof HTMLFormElement
    }

    _isObject(data) {
        return data && data.constructor === Object
    }

    _isArray(data) {
        return data && data.constructor === Array
    }
}

class NorseClient {
    constructor(url = '') {
        this.csrfToken = '{{ csrf_token }}'
        this.url = url

        this.actionId = null
        this.toaster = null
        this.isManualCatchEnabled = false

        this.errorHandler = this.genericErrorHandler
        this._onReject = (error) => {
            if (error instanceof NetworkError) {
                if(error?.message === "Request aborted") {
                    //  Sometimes when user clicks too frequently, an action might be in process
                    // when user decided to redirect to another page.
                    return
                }

                //  No response in the error object most probably because of network error
                console.error('Network error: ', error)
                this.toaster.addMessage(error.message, 'error')
                return
            }

            if (error instanceof ForbiddenError) {
                // Either session timed out or user switched to another profile
                window.location = '/'
                return
            }

            if (error instanceof RequestClientError) {
                let message = error?.response?.data?.message
                if (message) {
                    this.toaster.addMessage(message, 'error')
                    return
                }

                this.toaster.addMessage(gettext('Not allowed to do that'), 'error')
            }

            // 500 below
            if (error instanceof UnexpectedError) {
                // console.error(error)
                ErrorHandler.processUnexpectedError(this.toaster, error, this.actionId)
                return
            }

            return this.errorHandler(error)
        }
    }

    setToaster(toaster) {
        this.toaster = toaster
    }

    setErrorHandler(errorHandler) {
        this.errorHandler = errorHandler
    }

    genericErrorHandler(error) {
        // [!]  Toaster is not accessible here
        if (!this.toaster) {
            throw 'You need to have toaster set on the NorseClient.'
        }
        ErrorHandler.processError(this.toaster, error, HttpStatus.BAD_REQUEST)
    }

    enableManualCatch() {
        this.isManualCatchEnabled = true
        let handler = (error) => {
            throw error
        }
        this.setErrorHandler(handler)
    }

    get(data = {}) {
        let config = this.formConfig
        config['params'] = data
        let get = axios.get(this.url, config)

        let wrap = new Promise((outer_resolve) => {
            get.then((response) => {
                outer_resolve(response)
            }).catch((error) => {
                ErrorHandler.processError(error)
            })
        })
        return wrap
    }

    getNorseData(data, actionID) {
        this.actionId = actionID
        let norseData = NorseClientData.getNorseClientData(data)
        norseData.addData('action', actionID)
        return norseData
    }

    getFormData(data) {
        if (data instanceof NorseClientData) {
            return data.getFormData()
        }
        let norseData = new NorseClientData(data)
        return norseData.getFormData()
    }

    post(data = {}, config = this.formConfig) {
        let formData = this.getFormData(data)
        if (!this.url) {
            this.url = formData.get('action_url') || ''
        }
        let post = axios
            .post(this.url, formData, config)
            .catch((error) => {
                const instance = resolveError(error)
                throw instance
            })

        return new Promise((outerResolve, outerReject) => {
            return post.then(outerResolve, this._onReject)
                .catch((error) => {

                    if (this.isManualCatchEnabled) {
                        return outerReject(error)
                    }

                    // [!]  There is an error in the error handler
                    const msg = 'Error in error handler: ' + error.message
                    this.toaster.addMessage(msg, 'error')
                })
        })
    }

    hasGenericErrorHandler() {
        return this.errorHandler === this.genericErrorHandler
    }

    get formConfig() {
        return {
            'xsrfCookieName': 'sleipner-csrf',
            'xsrfHeaderName': 'X-CSRFTOKEN',
            headers: {
                'Content-Type': ContentType.URL_ENCODED,
                'X-Requested-With': 'XMLHttpRequest'
            }
        }
    }
}

class HTTPResponseError {
    constructor(response) {
        this.response = response
    }
}

class JSONBadRequestError extends HTTPResponseError {
    constructor(response) {
        super(response)

        this.message = 'Unhandled error'
        if (response.data.message) {
            this.message = response.data.message
        }
    }
}

class HTMLBadRequestError extends HTTPResponseError {
    constructor(response) {
        super(response)
        this.html_content = response.data
    }
}

class NetworkError {
    constructor(error) {
        this.message = error.message
    }
}

class UnexpectedError {
    constructor(error) {
        this.originalError = error
        this.response = error.response
    }
}

class ForbiddenError {
    constructor(error) {
        this.originalError = error
        this.response = error.response
    }
}

class RequestClientError {
    constructor(error) {
        this.originalError = error
        this.response = error.response
    }
}


function resolveError(error) {
    if (!error.response) {
        return new NetworkError(error)
    }

    const response = error.response
    if (response.status === HttpStatus.BAD_REQUEST) {
        if (response.norseTools.isHTML()) {
            return new HTMLBadRequestError(response)
        }

        if (response.norseTools.isJSON()) {
            return new JSONBadRequestError(response)
        }
    }

    if (response.status === HttpStatus.FORBIDDEN) {
        return new ForbiddenError(error)
    }

    if (response.status > 400 && 500 > response.status) {
        return new RequestClientError(error)
    }

    return new UnexpectedError(error)
}

const getDay = (date) => {
    return moment(new Date(date)).locale('sv').format('dddd')
}

const getDate = (date) => {
    return moment(new Date(date)).locale('sv').date()
}

const getWeek = (date) => {
    return moment(new Date(date)).locale('sv').isoWeek()
}

const getMonth = (date) => {
    return moment(new Date(date)).locale('sv').format('MMM')
}

const getYear = (date) => {
    return moment(new Date(date)).locale('sv').format('YYYY')
}

const isCurrentYear = (date) => {
    return moment(date).year() === moment(new Date()).year()
}

const isCurrentWeek = (date) => {

    if (!isCurrentYear(date)) {
        return false
    }

    return getWeek(date) === getWeek(new Date())
}

const isCurrentDay = (date) => {
    return moment(date).format(SETTINGS.DATE) === moment(new Date()).format(SETTINGS.DATE)
}

const isFirstOfMonth = (date) => {
    return moment(date).date() === 1
}


class DateUtility {

    static getObjFromString(dateString) {
        return moment(dateString, SETTINGS.DATE).toDate()
    }

    static getArrayFromStringRange(dateStringArray) {
        return [this.getObjFromString(dateStringArray[DATE_RANGE.FROM_DATE]),
            this.getObjFromString(dateStringArray[DATE_RANGE.TO_DATE])]
    }

    static getFirstDateFromRangeString(rangeString) {
        return rangeString.split(" - ")[0]
    }

    static getEndDateByWorkdays(startDate, daysToAdd) {
        const Sunday = 0
        const Saturday = 6
        let daysRemaining = daysToAdd
        const newDate = moment(startDate, SETTINGS.DATE)
        while (daysRemaining > 0) {
            newDate.add(1, 'days')
            if (newDate.day() !== Sunday && newDate.day() !== Saturday) {
                daysRemaining--
            }
        }

        return newDate
    }
}

class NorseElement {
    static getInputDataFromElement(elementId) {
        let rootElement = document.getElementById(elementId)
        if (!rootElement) {
            throw Error('No element with id: ' + elementId)
        }

        return this.extractInputDataFromElement(rootElement)
    }

    static extractInputDataFromElement(element) {
        let data = {}
        let elements = element.querySelectorAll('input, textarea, select')
        for (let element of elements) {
            if ('name' in element.attributes) {
                const name = element.attributes['name'].value.split(' ')[0]
                if (element.tagName === 'INPUT' && element.type === 'radio') {
                    if (element.checked) {
                        data[name] = element.value
                    }
                    continue
                }
                if (element.tagName === 'INPUT' && element.type === 'checkbox') {
                    if (!element.checked) {
                        continue
                    }
                    if (data.hasOwnProperty(name)) {
                        data[name].push(element.value)
                        continue
                    }
                    data[name] = [element.value]
                    continue
                }
                data[name] = element.value
            }
        }
        return data
    }

    static isChildOf(child, parent) {
        while ((child = child.parentNode) && child !== parent) {
        }
        return !!child
    }

    static removeElementById(elementId) {
        let element = document.getElementById(elementId)
        if (element) {
            element.remove()
            return false
        }
        throw 'Element not found. elementId:' + elementId
    }
}


class NorseForm {
    static DEFAULT_FORM_ID = 'default-form-id'

    constructor(id = null) {
        if (!id) {
            this.norseData = new NorseClientData({})
            return
        }
        this.formId = id
        let element = document.getElementById(id)
        if (this._isFormElement(element)) {
            this.norseData = new NorseClientData(element)
            return
        }

        let data = NorseElement.extractInputDataFromElement(element)
        this.norseData = new NorseClientData(data)
    }

    getData() {
        return this.norseData
    }

    getDataAsDict() {
        return this.norseData.getDataAsDict()
    }

    getFormId() {
        return this.formId
    }

    addFields(data) {
        Object.entries(data).forEach(([key, value]) => {
            if (value instanceof Array) {
                this._addFormsetField(key, value)
            } else {
                this.norseData.addData(key, value)
            }
        })
    }

    setFields(data) {
        Object.entries(data).forEach(([key, value]) => {
            this.norseData.setData(key, value)
        })
    }

    addFiles(key, array) {
        array.forEach(value => {
            this.norseData.addData(key, value)
        })
    }

    addGeoPointField(name, pointCoords) {
        const pointDict = {
            'longitude': pointCoords[0],
            'latitude': pointCoords[1]
        }
        let value = JSON.stringify(pointDict)
        this.norseData.addData(name, value)
    }

    addGeoPointListField(name, pointCoordsList) {
        let pointDictList = []
        for (const i in pointCoordsList) {
            pointDictList.push({
                'longitude': pointCoordsList[i][0],
                'latitude': pointCoordsList[i][1],
            })
        }
        this._addFormsetField(name, pointDictList)
    }

    // the added data has to be an array of dicts
    _addFormsetField(name, arrayOfDicts) {
        let value = JSON.stringify(arrayOfDicts)
        this.norseData.addData(name, value)
    }

    _isFormElement(element) {
        return element instanceof HTMLFormElement
    }
}

function getObjectByPk(pk, array) {
    for (let i = 0; i < array.length; ++i) {
        if (pk === array[i].pk) {
            return array[i]
        }
    }
    return null
}

function getObjectById(id, array) {
    for (let i = 0; i < array.length; ++i) {
        if (id === array[i].id) {
            return array[i]
        }
    }
    return null
}

function getObjectFromArray(array, key, value) {
    return array.find(obj => obj[key] === value)
}

function parseSearchTerms(query) {
    return String(query || '').toLowerCase().split(/\s+/).filter(Boolean)
}

/*
*   Ordered-terms search match: every whitespace-separated term in
*   `query` must appear in `text` (case-insensitive), in the typed
*   order, but not necessarily adjacent. 'snap drive os' matches
*   'Snap Drive AS Os' but not 'Snap Os Drive'. Mirrors the
*   backend's build_search_query (norse_common/filter_mixins.py).
* */
function matchesOrderedSearchTerms(text, query) {
    const haystack = String(text || '').toLowerCase()
    let position = 0
    for (const term of parseSearchTerms(query)) {
        const index = haystack.indexOf(term, position)
        if (index === -1) {
            return false
        }
        position = index + term.length
    }
    return true
}

/*
*   This is the safe variant of Objects.assign
*   d2 has precedence over d1
* */
function mergeTwoDicts(d1, d2) {
    return [d1, d2].reduce(function (r, o) {
        Object.keys(o).forEach(function (k) {
            r[k] = o[k]
        })
        return r
    }, {})
}

function removeFromArray(arr, value) {
    for (let i = 0; i < arr.length; i++) {
        if (arr[i] === value) {
            arr.splice(i, 1)
            i--
        }
    }
}

function removeFromArrayByPk(arr, pk) {
    for (let i = 0; i < arr.length; i++) {
        if (arr[i].pk === pk) {
            arr.splice(i, 1)
            i--
        }
    }
}

/*
*   Returns:  keys that
* */
function getSameKeys(d1, d2) {
    let keys = []
    for (const key in d1) {
        if (key in d2) {
            keys.push(key)
        }
    }
    return keys
}

function getErrorTitleFromResponse(errorResponseDataStr) {
    let pattern = '<title>'
    const index = errorResponseDataStr.search(pattern)
    if (index !== 0 && index !== -1) {
        const startIndex = index + pattern.length
        pattern = ' at '
        const endIndex = errorResponseDataStr.search(pattern)

        if (endIndex !== 0 && endIndex !== -1) {
            return errorResponseDataStr.substring(startIndex, endIndex)
        }
    }
    return null
}

function parseDateString(value) {
    if (!value) {
        return null
    }
    // Handles both moment, Date, and string inputs
    if (moment.isMoment(value)) {
        return value
    }
    if (value instanceof Date) {
        return moment(value)
    }
    const parsed = moment(value, SETTINGS.DATE, true)
    return parsed.isValid() ? parsed : null
}

const DEBOUNCE_TIMER = 200
const ONE_KILOMETER = 1000
const FLOATING_POINT_PRECISION = 2

function _debounce(cb, ms = DEBOUNCE_TIMER) {
    if (this.timer) {
        clearTimeout(this.timer)
    }

    this.timer = setTimeout(cb, ms)
}


class PointOfInterestMarker {
    fromBEData(data) {
        this.id = data.id
        this.longitude = data.longitude
        this.latitude = data.latitude
        this.pk = data?.pk


        this.properties = data?.properties
        if (this.properties) {
            this.properties['address'] = data?.properties.address
            this.properties['name'] = data?.properties.name
            this.properties['phone'] = data?.properties.phone
            this.properties['description'] = data?.properties.description
            this.properties['poi_type'] = data?.properties.poi_type
            this.properties['icon'] = 'main-icon'
            this.properties['coordKey'] = `${this.longitude},${this.latitude}`;
        }

        this.geometry = {
            'type': 'Point',
            'coordinates': [this.longitude, this.latitude]
        }
    }
}

class FacilityMarker {
    fromBEData(data, icon = null) {
        this.id = data.id
        this.longitude = data.longitude
        this.latitude = data.latitude

        this.pk = data?.pk
        this.name = data?.name
        this.address = data?.address
        this.postalCode = data?.postal_code
        this.postalCity = data?.postal_city

        this.properties = data?.properties
        if (this.properties) {
            this.properties['icon'] = icon ? icon : this.getServiceIcon(data)
            this.properties['coordKey'] = `${this.longitude},${this.latitude}`;
            // Discrepancy fields TODO: TBD Not finished
            this.properties['disabled'] = this.properties['disabled'] === 1 // Temp
            this.properties['auditTargets'] = this.properties['audit_targets']
            this.properties['isFacilityInactive'] = this.properties['is_facility_inactive'] === true
        }

        this.geometry = {
            'type': 'Point',
            'coordinates': [this.longitude, this.latitude]
        }
    }

    getServiceIcon(data) {
        // The grey pin is registered by
        // MapMarkerImageFactory.registerServiceTypeImages.
        if (!data?.properties?.is_facility_inactive) return data?.facility_type
        return data.facility_type + MapMarkerImageFactory.INACTIVE_ICON_SUFFIX
    }
}

class MapboxRoute {
    /**
     * @param {mapboxgl.Map} map
     * @param {{
     *   sourceId?: string,
     *   lineLayerId?: string,
     *   haloLayerId?: string,
     *   dotsLayerId?: string,
     *   labelsLayerId?: string,
     *   hitboxLayerId?: string,
     *   showInitially?: boolean,
     *   promoteIdProperty?: string,
     *   enableHitbox?: boolean,
     *   enableLabels?: boolean
     * }} options
     */
    constructor(map, options = {}) {
        this.map = map;

        // Ids & options
        this.sourceId = options.sourceId || 'n-routes-src';
        this.lineLayerId = options.lineLayerId || 'n-routes-line';
        this.haloLayerId = options.haloLayerId || 'n-routes-halo';
        this.dotsLayerId = options.dotsLayerId || 'n-routes-dots';
        this.labelsLayerId = options.labelsLayerId || 'n-routes-labels';
        this.hitboxLayerId = options.hitboxLayerId || 'n-routes-hitbox';
        this.promoteIdProperty = options.promoteIdProperty || 'route_id';

        // Opt-in features. Both default off so existing consumers
        // (n-mapbox-route-list, create-route routes drawer, etc.)
        // are byte-identical to before until they explicitly turn
        // these on.
        //
        //  • enableHitbox — adds a transparent ~24px-wide line
        //    layer above the visible line. Pointer events bind
        //    to this layer instead of the narrow visible one, so
        //    the route is much easier to hover/click without
        //    making the line itself visually thicker.
        //
        //  • enableLabels — adds a `symbol` layer with
        //    `symbol-placement: line-center` showing the route
        //    name at the midpoint, in the route's colour with a
        //    white halo. Mapbox's collision engine culls labels
        //    that don't fit at low zoom; at higher zoom every
        //    visible route is labelled.
        this.enableHitbox = Boolean(options.enableHitbox);
        this.enableLabels = Boolean(options.enableLabels);

        // State
        this.showRoutes = Boolean(options.showInitially ?? true);
        this.selectedRouteIds = [];
        this.hoveredRouteFeatureId = null;
        this.routePopup = null;
        this.eventsBound = false;

        this._features = [];
        this._featureIndex = new Map();
    }


    init(routeFeatures = []) {
        this.ensureSource(routeFeatures);
        this.ensureLayers();
        this.bindHoverEventsOnce();
        this.applyVisibility();
        this.applySelectionFilter();
    }


    ensureSource(routeFeatures) {
        if (!this.map.getSource(this.sourceId)) {
            this.map.addSource(this.sourceId, {
                type: 'geojson',
                promoteId: this.promoteIdProperty,
                data: {
                    type: 'FeatureCollection',
                    features: Array.isArray(routeFeatures) ? routeFeatures : [],
                },
            });
        }
    }


    ensureLayers() {
        if (!this.map.getLayer(this.haloLayerId)) {
            this.map.addLayer({
                id: this.haloLayerId,
                type: 'line',
                source: this.sourceId,
                filter: ['==', ['get', 'kind'], 'route'],
                layout: {'line-cap': 'round', 'line-join': 'round', visibility: 'none'},
                paint: {
                    'line-color': ['coalesce', ['get', 'color'], '#3e89ff'],
                    'line-width': [
                        'case',
                        ['boolean', ['feature-state', 'hover'], false], 10, 0
                    ],
                    'line-opacity': [
                        'case',
                        ['boolean', ['feature-state', 'hover'], false], 0.6, 0
                    ],
                    'line-blur': [
                        'case',
                        ['boolean', ['feature-state', 'hover'], false], 2, 0
                    ],
                },
            });
        }

        if (!this.map.getLayer(this.lineLayerId)) {
            this.map.addLayer({
                id: this.lineLayerId,
                type: 'line',
                source: this.sourceId,
                filter: ['==', ['get', 'kind'], 'route'],
                layout: {'line-cap': 'round', 'line-join': 'round', visibility: 'none'},
                paint: {
                    'line-color': ['coalesce', ['get', 'color'], '#3887be'],
                    'line-width': [
                        'case',
                        ['boolean', ['feature-state', 'hover'], false], 6, 4
                    ],
                    'line-opacity': 0.9,
                },
            });
        }

        // ── Labels layer (opt-in) ──────────────────────────────
        // One label per route at the geometric centre of the line.
        // `text-rotation-alignment: map` rotates the label with the
        // line direction; `text-keep-upright` flips it 180° if the
        // line direction would otherwise render text upside-down.
        // Mapbox's collision engine culls labels that don't fit, so
        // at country zoom only a few routes are labelled and at
        // city zoom they all are — no manual zoom-stop wiring.
        //
        // Added BEFORE the hitbox so the hitbox sits on top in the
        // layer stack: that way pointer events on label pixels
        // (which can extend slightly beyond the line bounds on
        // curves) still land on the hitbox underneath.
        if (this.enableLabels && !this.map.getLayer(this.labelsLayerId)) {
            this.map.addLayer({
                id: this.labelsLayerId,
                type: 'symbol',
                source: this.sourceId,
                filter: ['==', ['get', 'kind'], 'route'],
                layout: {
                    'symbol-placement': 'line-center',
                    'text-field': ['coalesce', ['get', 'name'], ''],
                    'text-size': 16,
                    'text-font': ['Open Sans Semibold', 'Arial Unicode MS Bold'],
                    // 4px collision buffer so adjacent labels don't
                    // touch even when the algorithm could fit them.
                    'text-padding': 4,
                    'text-allow-overlap': false,
                    'text-ignore-placement': false,
                    // Rotate with the line geometry, but keep
                    // upright relative to the viewport so a tilted
                    // map doesn't tip the text on its side.
                    'text-rotation-alignment': 'map',
                    'text-pitch-alignment': 'viewport',
                    'text-keep-upright': true,
                    'text-letter-spacing': 0.02,
                    visibility: 'none',
                },
                paint: {
                    // Text picks up the route's colour so the line
                    // and its label are visually tied together
                    // (Strava / Komoot pattern). White halo keeps
                    // it legible against the light Mapbox basemap
                    // even for the lighter route colours.
                    'text-color': ['coalesce', ['get', 'color'], '#3887be'],
                    'text-halo-color': '#ffffff',
                    'text-halo-width': 1.5,
                    'text-halo-blur': 0.5,
                },
            });
        }

        // ── Hitbox layer (opt-in) ──────────────────────────────
        // Transparent fat line that catches pointer events. Mapbox
        // still fires mouseenter / mouseleave / click on layers
        // with `line-opacity: 0`, so the user gets a generous
        // 24px-wide target while the visible line stays at 4-6px.
        // This is the same "fat-line trick" Strava, Komoot and
        // Felt use; the visible line stays pretty, hover stops
        // feeling like dart practice.
        //
        // Added LAST so it sits on top of labels in the layer
        // stack — that ensures the cursor always lands on the
        // hitbox regardless of where on the route the cursor is.
        if (this.enableHitbox && !this.map.getLayer(this.hitboxLayerId)) {
            this.map.addLayer({
                id: this.hitboxLayerId,
                type: 'line',
                source: this.sourceId,
                filter: ['==', ['get', 'kind'], 'route'],
                layout: {
                    'line-cap': 'round',
                    'line-join': 'round',
                    visibility: 'none',
                },
                paint: {
                    // Colour is irrelevant — line-opacity:0 means
                    // no pixels are drawn. Mapbox keeps firing
                    // pointer events on zero-opacity features.
                    'line-color': '#000000',
                    'line-width': 24,
                    'line-opacity': 0,
                },
            });
        }
    }


    setData(routeFeatures = []) {
        const source = this.map.getSource(this.sourceId);
        if (!source) {
            this.ensureSource(routeFeatures);
            this.ensureLayers();
            this.bindHoverEventsOnce();
        } else {
            source.setData({
                type: 'FeatureCollection',
                features: Array.isArray(routeFeatures) ? routeFeatures : [],
            });
        }
        this.applySelectionFilter();
    }


    setVisibility(shouldShow) {
        this.showRoutes = Boolean(shouldShow);
        this.applyVisibility();
        // Hide hover popup when hiding routes
        if (!this.showRoutes && this.routePopup) {
            this.routePopup.remove();
        }
    }

    applyVisibility() {
        const visibility = this.showRoutes ? 'visible' : 'none';
        // Includes hitbox + labels alongside the visible layers so
        // toggling visibility hides/shows the whole route stack —
        // not just the painted parts.
        [
            this.haloLayerId,
            this.lineLayerId,
            this.labelsLayerId,
            this.hitboxLayerId,
            this.dotsLayerId,
        ]
            .filter(layerId => this.map.getLayer(layerId))
            .forEach(layerId => this.map.setLayoutProperty(layerId, 'visibility', visibility));
    }


    setSelectedRouteIds(routeIds) {
        this.selectedRouteIds = Array.isArray(routeIds) ? routeIds.slice() : [];
        this.applySelectionFilter();
    }


    buildSelectionFilterExpression() {
        const baseFilter = ['==', ['get', 'kind'], 'route'];
        const idsToShow = this.selectedRouteIds.length ? this.selectedRouteIds : ['__none__'];
        const onlySelectedFilter = ['in', ['get', this.promoteIdProperty], ['literal', idsToShow]];
        return ['all', baseFilter, onlySelectedFilter];
    }

    applySelectionFilter() {
        const filterExpression = this.buildSelectionFilterExpression();

        // Hitbox + labels need the same filter as the visible
        // line/halo, otherwise hidden routes would still catch
        // pointer events (hitbox) or render their text (labels).
        const targetLayers = [
            this.lineLayerId,
            this.haloLayerId,
            this.hitboxLayerId,
            this.labelsLayerId,
        ];
        for (const layerId of targetLayers) {
            if (this.map.getLayer(layerId)) {
                this.map.setFilter(layerId, filterExpression);
            }
        }
    }


    bindHoverEventsOnce() {
        if (this.eventsBound) return;
        // Bind to the hitbox if it exists; otherwise fall back to
        // the visible line for backwards compatibility with
        // existing consumers that don't opt into enableHitbox.
        const targetLayerId = (
            this.enableHitbox && this.map.getLayer(this.hitboxLayerId)
        ) ? this.hitboxLayerId : this.lineLayerId;
        if (!this.map.getLayer(targetLayerId)) return;

        this.routePopup = this.routePopup || new mapboxgl.Popup({
            closeButton: false,
            closeOnClick: false,
            className: 'n-route-popup',
            offset: 10,
        });

        const handleEnter = (event) => {
            this.map.getCanvas().style.cursor = 'pointer';
            const feature = event.features && event.features[0];
            if (!feature) return;

            const featureId = feature.properties?.[this.promoteIdProperty];
            if (featureId == null) return;

            if (this.hoveredRouteFeatureId !== null) {
                this.map.setFeatureState(
                    {source: this.sourceId, id: this.hoveredRouteFeatureId},
                    {hover: false}
                );
            }

            this.hoveredRouteFeatureId = featureId;
            this.map.setFeatureState(
                {source: this.sourceId, id: featureId},
                {hover: true}
            );
            const name = feature.properties?.name || `Route ${String(featureId)}`;
            this.routePopup.setLngLat(event.lngLat).setText(name).addTo(this.map);
        };

        const handleMove = (event) => {
            if (!this.routePopup) return;
            this.routePopup.setLngLat(event.lngLat);
        };

        const handleLeave = () => {
            this.map.getCanvas().style.cursor = '';
            if (this.hoveredRouteFeatureId !== null) {
                this.map.setFeatureState(
                    {source: this.sourceId, id: this.hoveredRouteFeatureId},
                    {hover: false}
                );
                this.hoveredRouteFeatureId = null;
            }
            if (this.routePopup) this.routePopup.remove();
        };

        const handleClick = (event) => {
            const feature = event.features?.[0];
            if (!feature) return;
            const featureId = feature.properties?.[this.promoteIdProperty];
            const name = feature.properties?.name || `Route ${String(featureId ?? '')}`;
            new mapboxgl.Popup({closeButton: true})
                .setLngLat(event.lngLat)
                .setText(name)
                .addTo(this.map);
        };

        this.map.on('mouseenter', targetLayerId, handleEnter);
        this.map.on('mousemove', targetLayerId, handleMove);
        this.map.on('mouseleave', targetLayerId, handleLeave);
        this.map.on('click', targetLayerId, handleClick);

        this.eventsBound = true;
    }

    /**
     * Clean up (optional).
     */
    destroy() {
        try {
            if (this.map.getLayer(this.lineLayerId)) this.map.removeLayer(this.lineLayerId);
            if (this.map.getLayer(this.haloLayerId)) this.map.removeLayer(this.haloLayerId);
            if (this.map.getLayer(this.dotsLayerId)) this.map.removeLayer(this.dotsLayerId);
            if (this.map.getLayer(this.labelsLayerId)) this.map.removeLayer(this.labelsLayerId);
            if (this.map.getLayer(this.hitboxLayerId)) this.map.removeLayer(this.hitboxLayerId);
            if (this.map.getSource(this.sourceId)) this.map.removeSource(this.sourceId);
            if (this.routePopup) this.routePopup.remove();
        } catch (error) {
            console.error('Route.destroy error:', error);
        }
        this.eventsBound = false;
        this.hoveredRouteFeatureId = null;
    }
}


class MapBoxUtility {
    static totalTime = 0           /// In hours
    static totalAuditTime = 0      /// In hours.
    static totalTravelTime = 0     /// In seconds.
    static totalDistance = 0       /// In km


    static getCachedMapData() {
        const cached = window.localStorage.getItem('mapdata')
        if (cached) {
            return JSON.parse(cached)
        }
        return null
    }

    static setCachedMapData(data) {
        window.localStorage.setItem('mapdata', JSON.stringify(data))
    }

    /**
     * Cached existing-routes data (the GeoJSON feature collection
     * returned by `_planner_get_routes_map_data`). Routes change
     * infrequently, so we mirror the markers' cache-then-refetch
     * pattern: hand back the cached snapshot for instant first paint,
     * then overwrite once the backend response lands.
     */
    static getCachedRoutesData() {
        try {
            const cached = window.localStorage.getItem('routesdata')
            return cached ? JSON.parse(cached) : null
        } catch (_) {
            // Corrupt JSON in storage — wipe it and start fresh.
            window.localStorage.removeItem('routesdata')
            return null
        }
    }

    static setCachedRoutesData(data) {
        try {
            window.localStorage.setItem('routesdata', JSON.stringify(data))
        } catch (_) {
            // Quota exceeded or storage unavailable — silently skip.
        }
    }

    static clearCachedFilters() {
        window.localStorage.setItem('filters', JSON.stringify(MAPBOX_FILTERS))
        window.localStorage.setItem('activeRegionIds', JSON.stringify([]))
    }

    static loadValidatedFilters() {
        const saved = window.localStorage.getItem('filters');

        if (!saved) {
            return {...MAPBOX_FILTERS}; // nothing saved, return defaults
        }

        try {
            const parsed = JSON.parse(saved);

            // Compare keys between parsed filters and MAPBOX_FILTERS
            const savedKeys = Object.keys(parsed);
            const expectedKeys = Object.keys(MAPBOX_FILTERS);

            const hasMismatch =
                savedKeys.length !== expectedKeys.length ||
                savedKeys.some((key) => !expectedKeys.includes(key));

            if (hasMismatch) {
                // Clear invalid filters and reset
                window.localStorage.removeItem('filters');
                return {...MAPBOX_FILTERS};
            }

            return parsed; // valid structure
        } catch (e) {
            console.warn('Invalid filters in localStorage, resetting.', e);
            window.localStorage.removeItem('filters');
            return {...MAPBOX_FILTERS};
        }
    }

    static getReboundSelectedLocations(data, locations) {
        const byPkNew = new Map(data.data.features.map(feature => [feature.pk, feature]))
        return (locations || [])
            .map(selected => byPkNew.get(selected.pk))
            .filter(Boolean)
    }

    static setIsAdHocOnFacility(facility) {
        facility.properties['is_adhoc'] = true
    }

    static setTotalTravelTime(json) {
        const trip = json.trips[0]
        this.totalTravelTime = trip.duration
        this.totalDistance = MapBoxUtility.metersToKm(trip.distance)
        this.obtainTotalTime()
        return this.hoursToHHMM(this.totalTime)
    }

    static setTotalAuditTime(facilities) {
        this.totalAuditTime = 0
        facilities.forEach((facility) => {
            this.totalAuditTime += facility?.duration
        })
    }

    static setSelectedAudits(to, from) {
        to.duration = from.duration
        to.properties.durationTime = from.properties.durationTime
        to.properties.audits = from.properties.audits
    }

    static setTravelTimeOnFacilities(json, facilities, endPoint) {
        //  Expecting facilities count to be exactly corresponding to legs in the json.
        // This includes corresponding to order as well.
        if (facilities.length === 0) {
            return
        }

        const legs = json.trips[0].legs
        for (let i = 0; i < legs.length; ++i) {
            const leg = legs[i]
            if (i === legs.length - 1) {
                endPoint.travelTime = MapBoxUtility.secondsToHHMM(leg.duration)
                break
            }

            let facility = facilities[i]
            facility.properties['travelTime'] = MapBoxUtility.secondsToHHMM(leg.duration)
        }
    }

    static addSelectedAuditToFacility(facility, auditPk, auditDuration) {
        if (!facility.properties.selectedAudits) {
            facility.properties.selectedAudits = []
        }
        facility.properties.selectedAudits.push({
            'pk': auditPk,
            'duration': auditDuration
        })
    }

    static removeSelectedAuditFromFacility(facility, auditPk) {
        facility.properties.selectedAudits = facility.properties.selectedAudits
            .filter(audit => audit.pk !== auditPk)
    }

    static getSelectedAuditsDuration(facility) {
        let facilityTotalDuration = 0
        facility.properties.selectedAudits.forEach(audit => {
            facilityTotalDuration += audit.duration
        })
        return facilityTotalDuration
    }

    static addAuditDuration(facility, auditDuration) {
        const facilityDuration = this.getSelectedAuditsDuration(facility)
        facility.duration = facilityDuration
        facility.properties.durationTime = this.hoursToHHMM(facilityDuration)

        this.totalAuditTime += auditDuration
        this.obtainTotalTime()
        return this.hoursToHHMM(this.totalTime)
    }

    static removeAuditDuration(facility, auditDuration) {
        const facilityDuration = this.getSelectedAuditsDuration(facility)
        facility.duration = facilityDuration
        facility.properties.durationTime = this.hoursToHHMM(facilityDuration)

        this.totalAuditTime -= auditDuration
        this.obtainTotalTime()
        return this.hoursToHHMM(this.totalTime)
    }

    static getTotalTravelTime() {
        return this.secondsToHHMM(this.totalTravelTime)
    }

    static getTotalDistance() {
        return this.totalDistance
    }

    static obtainTotalTime() {
        this.totalTime = this.totalTravelTime / 3600.0 + this.totalAuditTime
    }

    static getSelectedAudit(facility, auditPk) {
        for (let i = 0; i < facility.properties.selectedAudits.length; ++i) {
            const audit = facility.properties.selectedAudits[i]
            if (audit.pk === auditPk) {
                return audit
            }
        }
        return null
    }

    static getSelectedAuditFromFacilities(facilities, auditPk) {
        for (let i = 0; i < facilities.length; ++i) {
            const audit = MapBoxUtility.getSelectedAudit(facilities[i], auditPk)
            if (audit) {
                return audit
            }
        }
        return null
    }

    static getPointCoords(waypoint) {
        let coords = waypoint?.geometry?.coordinates
        if (!coords) {
            return waypoint.center
        }
        return [coords[0], coords[1]]
    }

    static getPointCoordsList(waypointList) {
        let geoPointList = []
        for (const key in waypointList) {
            geoPointList.push(MapBoxUtility.getPointCoords(waypointList[key]))
        }
        return geoPointList
    }

    static getObjectIDs(objects) {
        let ids = []
        for (const key in objects) {
            ids.push(objects[key].id)
        }
        return ids
    }

    static metersToKm(meters) {
        return (meters / ONE_KILOMETER).toFixed(FLOATING_POINT_PRECISION)
    }

    static secondsToHHMM(seconds) {
        const hours = Math.floor(seconds / 3600)
        const minutes = Math.floor((seconds % 3600) / 60)
        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`
    }

    static hoursToHHMM(decimalHours) {
        // Calculate hours and minutes
        let hours = Math.floor(decimalHours)
        let minutes = Math.round((decimalHours - hours) * 60)
        if (minutes === 60) {
            minutes = 0
            hours += 1
        }

        // Format hours and minutes as two digits
        const formattedHours = hours.toString().padStart(2, '0')
        const formattedMinutes = minutes.toString().padStart(2, '0')
        return `${formattedHours}:${formattedMinutes}`
    }

    static isValidImage(image) {
        if (!image.url) {
            return false
        }
        if (!image.name) {
            return false
        }
        return true
    }

    static calculateCoordinates(coordinates, lng) {
        // Ensure that if the map is zoomed out such that multiple
        // copies of the feature are visible, the popup appears
        // over the copy being pointed to.
        const PRESSED_ICON_INDEX = 0
        const DEGREES_ONE_EIGHTY = 180
        const DEGREES_THREE_SIXTY = 360
        const currentLng = coordinates[PRESSED_ICON_INDEX]
        if (Math.abs(lng - currentLng) > DEGREES_ONE_EIGHTY) {
            coordinates[PRESSED_ICON_INDEX] += lng > currentLng ? DEGREES_THREE_SIXTY : -DEGREES_THREE_SIXTY
        }
    }

    static getRegionData(backendRegionData) {
        let serializedRegions = []
        backendRegionData.forEach(regionData => {
            const region = new Region()
            region.fromBEData(regionData)
            serializedRegions.push(region)
        })
        return serializedRegions
    }

    static getStaticPlaceData(mapBEData) {
        let serializedFeatures = []

        for (let locationBEData of mapBEData) {
            const poi = new PointOfInterestMarker()
            poi.fromBEData(locationBEData)

            serializedFeatures.push(poi)
        }
        return serializedFeatures
    }

}

class StaticDataLayerManager {
    constructor(map, staticData, renderPopupCallback = null) {
        this.map = map
        this.staticData = staticData
        this.popup = new mapboxgl.Popup({
            className: 'n-map-popup-static',
            closeButton: false,
            offset: 25
        })
        this.renderPopupCallback = renderPopupCallback // this sucks, but I dont know how else to reach the component
    }

    async init() {
        await this.loadImages(POINT_OF_INTEREST_MARKERS)
        this.addSource()
        this.addLayer()
        this.addHoverEvents()
    }

    // Later POI reloads swap the data in place: running init() again
    // re-adds the images and the source, which Mapbox refuses.
    updateData(staticData) {
        this.staticData = staticData
        const source = this.map.getSource(this.staticData.layerID)
        // Still initialising: addSource() reads this.staticData.
        if (!source) return
        source.setData(this.staticData.data)
    }

    async loadImages(markers) {
        const promises = markers.map(image => {
            return new Promise((resolve, reject) => {
                if (MapBoxUtility.isValidImage(image)) {
                    this.map.loadImage(image.url, (error, img) => {
                        if (error) {
                            reject(error)
                            return
                        }
                        this.map.addImage(image.name, img)
                        resolve()
                    })
                } else {
                    console.error('Invalid image', image)
                    reject('Invalid image format')
                }
            })
        })

        return Promise.all(promises)
    }

    addSource() {
        this.map.addSource(this.staticData.layerID, {
            type: 'geojson',
            data: this.staticData.data,
        })
    }

    addLayer() {
        this.map.addLayer({
            id: this.staticData.layerID,
            type: 'symbol',
            source: this.staticData.layerID,
            filter: ['!', ['has', 'point_count']],
            layout: {
                'icon-image': [
                    'case',
                    ['==', ['get', 'poi_type'], POINT_OF_INTEREST_TYPE.DEFAULT], POINT_OF_INTEREST_TEMP_MARKER.name,
                    ['==', ['get', 'poi_type'], POINT_OF_INTEREST_TYPE.INSPECTOR], POINT_OF_INTEREST_INSPECTOR_MARKER.name,
                    'disabled'
                ],
                'icon-size': [
                    'interpolate', ['linear'], ['zoom'],
                    10, 1,
                    15, 1.5,
                    20, 2.0
                ],
                'icon-allow-overlap': true,
                'icon-ignore-placement': true
            }
        })
    }

    addHoverEvents() {
        const layerID = this.staticData.layerID

        this.map.on('mouseenter', layerID, e => {
            this.map.getCanvas().style.cursor = 'pointer'
            this.showPopup(e)
        })

        this.map.on('mouseleave', layerID, () => {
            this.map.getCanvas().style.cursor = ''
            this.popup.remove()
        })

        this.map.on('touchstart', layerID, e => {
            this.map.getCanvas().style.cursor = 'pointer'
            this.showPopup(e)
        })

        this.map.on('touchend', layerID, () => {
            this.map.getCanvas().style.cursor = ''
            this.popup.remove()
        })
    }

    showPopup(e) {
        const feature = e.features[0]
        const coordinates = feature.geometry.coordinates.slice()
        const lng = e.lngLat.lng

        MapBoxUtility.calculateCoordinates(coordinates, lng)

        if (!this.renderPopupCallback) return

        const popupContent = this.renderPopupCallback(feature.properties)
        this.popup.setLngLat(coordinates).setDOMContent(popupContent).addTo(this.map)
    }
}

class Region {
    fromBEData(data, color = '#d62728') {
        this.id = data.properties.id
        this.name = data.properties.name
        this.geometry = data.geometry
        this.color = data.properties?.color || color
    }
}


// Could be placed in constants but  I
// personally prefer it close to the implementation
const USE_DLOG = false;

function dlog(tag, ...args) {
    if (!USE_DLOG) return;
    // timestamps help correlate: [123.45ms] [tag] message
    const t = (performance.now() / 1000).toFixed(3);
    console.log(`[${t}s] [${tag}]`, ...args);
}
class NorseLoader {
    constructor() {
        this.actions = []
    };

    isLoading() {
        return this.actions.length > 0
    }

    isActionLoading(action) {
        return this.actions.includes(action)
    }


    _clearActions() {
        this.actions = []
    }

    dispatchStartLoading(action_id) {
        this.actions = [...this.actions, action_id]
    }

    dispatchStopLoading(action_id) {
        if (!action_id) {
            //Should mean that the view does not have any other actions.
            //safe to remove "all" actions
            this._clearActions()
            return
        }
        if (this.isActionLoading(action_id)) {
            this.actions = this.actions.filter((x) => {
                return x !== action_id
            })
        }

    }
}

class ErrorHandler {
    static processError(toaster, error, ignore_status) {
        if (error instanceof JSONBadRequestError) {
            if (error.response.data.message) {
                toaster.addMessage(error.response.data.message, 'error')
                return
            }

            toaster.addMessage(error.response.statusText, 'error')
            return
        }

        if (error.response) {
            toaster.addMessage(error.response.statusText, 'error')

            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            // console.log(error.response.data);
            // console.log(error.response.status);
            if (ignore_status && error.response.status === ignore_status) {
                return
            }
            if (error.response.status === HttpStatus.INTERNAL_SERVER_ERROR) {
                this.processUnexpectedError(toaster, error)
                return
            }

            let msg = this._resolveMsg(error.response)
            console.error(msg)
            return
        }
        if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest

            // app.showErrorMessage("Unhandled error");
            console.log('ERROR:', error)
            return
        }
        if (error instanceof PromiseRejectionEvent) {
            if (error.reason) {
                if (error.reason.response) {
                    let msg = this._resolveMsg(error.reason.response)
                    // app.showErrorMessage(msg + ", unhandled");
                    console.error(msg + ', unhandled')
                    return
                }
                // app.showErrorMessage(error.reason + " (unhandled)");
                console.error(error.reason + ' (unhandled)')
                return
            }
        }

        if (error instanceof NetworkError) {
            toaster.addMessage(error.message, 'error')
        }

        // Something happened in setting up the request that triggered an Error
        // app.showErrorMessage(error);
        console.error(error)
    }

    static processUnexpectedError(toaster, error, actionId = null) {
        let sentry_msg = 'Unexpected internal server error'
        const response = error.response
        if (response.status === HttpStatus.INTERNAL_SERVER_ERROR) {
            const errorTitle = getErrorTitleFromResponse(response.data)
            if (errorTitle) {
                sentry_msg = 'Internal server error: ' + errorTitle
            }
            if (!errorTitle) {
                sentry_msg = 'Unexpected internal server error'
            }
        }

        if (actionId) {
            sentry_msg += ' on: ' + actionId
        }

        if (!error.originalError) {
            Sentry.captureException(error)
            console.error(error)
            toaster.addMessage(error.message, 'error')
            return
        }

        console.error(error)
        error.originalError.message = sentry_msg
        Sentry.captureException(error.originalError)
        toaster.addMessage('Unexpected error occurred', 'error')
    }

    static _resolveMsg(response) {
        console.log('resolve msg', response)
        let msg = ''
        if (response.data) {
            if (response.data.message) {
                msg = response.data.message + ', ' + response.statusText + ' (' + response.status + ')'
                return msg
            }

            if (typeof response.data !== 'string') {
                return 'response.data is dict but does not contain a message.'
            }

            msg = '"' + response.data.substring(0, 32) + '", '
        }
        msg = msg + response.statusText + ' (' + response.status + ')'
        return msg
    }
}

class NorseComponent {
    static getError(fieldName, errors, element) {
        if (!element) {
            console.error('Need element to find the error!')
            return null
        }

        for (let formId in errors) {
            if (formId !== NorseForm.DEFAULT_FORM_ID) {
                let parentElement = document.getElementById(formId)
                if (!parentElement) {
                    console.error('Back-end returns errors for form that is not persistent in the DOM!')
                    continue
                }

                const isChild = NorseElement.isChildOf(element, parentElement)
                if (!isChild) {
                    continue
                }
            }

            let formErrors = errors[formId]
            for (let field in formErrors) {
                if (fieldName === field) {
                    return formErrors[field]
                }
            }
        }
        return null
    }
}

const TOAST_TIMER = 8000 // 8 seconds

class NorseToastHandler {

    constructor() {
        this.messages = []
    }

    addMessage(responseMessage, type = 'error') {
        this.messages.push({
            message: responseMessage,
            status: type,
            timeToLive:
                setTimeout(() => {
                    this.messages.shift()
                }, TOAST_TIMER),
            id: Symbol()
        })
    }

    addPersistentMessage(responseMessage, type = 'error') {
        this.messages.push({message: responseMessage, status: type, id: Symbol()})
    }

    addDjangoMessages(norseForm) {
        const WARNING_LEVEL = '30'
        const ERROR_LEVEL = '40'
        for (const key in norseForm.norseData.data) {
            let value = norseForm.norseData.data[key]
            value = value.split(';')
            const level = value[0]
            const message = value[1]
            if (level === WARNING_LEVEL) {
                this.addMessage(message, 'warning')
            } else if (level === ERROR_LEVEL) {
                this.addMessage(message, 'error')
            } else {
                this.addMessage(message, 'success')
            }
        }
    }

    removeMessage(message) {

        const spliceAtIndex = this.messages.findIndex((msg) => msg.id === message.id)

        if (spliceAtIndex === -1)
            return

        //Clear the timeout before removing it from array
        if (this.messages[spliceAtIndex]?.timeToLive) {
            clearTimeout(this.messages[spliceAtIndex].timeToLive)
        }

        this.messages.splice(spliceAtIndex, 1)
    }
}

const VALID_STORAGE_PATHS = [
    '/cab/cases/',
    '/cab/certificates/',
    '/cab/invoicing/',
    '/cab/io-management/',
    '/cab/applications/',
]

class NorseParamHandler {
    constructor() {
        this.builderParams = new Map()
        this.useStorage = VALID_STORAGE_PATHS.includes(window.location.pathname)
        this.usePushState = false

        if (this.useStorage) {
            const sessionParams = sessionStorage.getItem('urlParams_' + window.location.pathname)
            if (sessionParams) {
                this.initialUrlParams = new URLSearchParams(sessionParams)

                this.updateState(sessionParams)
                return
            }
        }
        this.initialUrlParams = new URLSearchParams(window.location.search) // URL as it is when app start
    }

    activatePushState(callback = undefined) {

        function defaultPopState() {
            window.location.reload()
        }

        window.onpopstate = (event) => {
            if (callback) {
                return callback()
            }
            return defaultPopState()
        }
        this.usePushState = true
    }

    deactivatePushState() {

    }

    updateState(params) {
        if (this.usePushState) {
            return window.history.pushState({}, '', params)
        }
        return window.history.replaceState({}, '', params)
    }

    clearInitial() {
        //Useful when we append the searchparams from backend,
        // then we can clean up the search params a little with this method
        this.initialUrlParams = new URLSearchParams()
    }

    registerParamBuilder(prefix) {
        if (!prefix) {
            console.error('Must register a parambuilder with a prefix')
            return
        }
        if (this.builderParams.has(prefix)) {
            return
        }

        let keysToDeleteFromInitial = new Set()
        let newParams = new URLSearchParams()

        for (let [key, value] of this.initialUrlParams.entries()) {
            if (key.includes(prefix)) {
                newParams.append(key, value)
                keysToDeleteFromInitial.add(key)
            }
        }

        keysToDeleteFromInitial.forEach(key => this.initialUrlParams.delete(key))

        const newParamBuilder = new NorseParamBuilder(prefix)
        newParamBuilder.params = newParams
        this.builderParams.set(prefix, newParamBuilder)
    }

    getOrRegisterParamBuilder(prefix) {
        let builder = this.builderParams.get(prefix)
        if (builder) {
            return builder
        }
        this.registerParamBuilder(prefix)
        return this.builderParams.get(prefix)
    }

    setBrowserParams() {
        let builderURLs = []
        this.builderParams.forEach((builder) => {
            const url = builder.getURL()
            if (url) {
                builderURLs.push(builder.getURL())
            }
        })
        const initialString = this.initialUrlParams.toString()
        let url = builderURLs.join('&')
        if (initialString) {
            url = `${url}&${initialString}`
        }

        pHandler.updateState('?' + url)
        this.useStorage && sessionStorage.setItem('urlParams_' + window.location.pathname, '?' + url)
    }

    extractUrlParamsFromSessionStorage() {
        let paramsObject = {}

        for (let i = 0; i < sessionStorage.length; i++) {
            const key = sessionStorage.key(i)
            if (key && key.startsWith('urlParams_')) {
                const pathname = key.replace('urlParams_', '')
                paramsObject[pathname] = sessionStorage.getItem(key)
            }
        }

        return paramsObject
    }

    createJsonBlobFromSessionStorage() {
        const paramsObject = this.extractUrlParamsFromSessionStorage()
        return JSON.stringify(paramsObject)
    }

    parseJsonBlob(jsonBlob) {
        try {
            return JSON.parse(jsonBlob)
        } catch (error) {
            console.error('Error parsing JSON blob:', error)
            return null
        }
    }

    loadParamsIntoSessionStorage(jsonBlob) {
        const paramsObject = this.parseJsonBlob(jsonBlob)

        if (paramsObject) {
            Object.keys(paramsObject).forEach(pathname => {
                const key = 'urlParams_' + pathname
                const value = paramsObject[pathname]
                sessionStorage.setItem(key, value)
            })
        }
    }

}

let pHandler = new NorseParamHandler()


class NorseParamBuilder {
    constructor(prefix = '') {
        this.prefix = prefix.toLowerCase()
        this.useStorage = VALID_STORAGE_PATHS.includes(window.location.pathname)
        const sessionParams = sessionStorage.getItem('urlParams_' + window.location.pathname) || window.location.search
        this.params = new URLSearchParams(sessionParams.split('?')[0])
    }

    _setParam(key, value) {
        this.params.set(`${this.prefix}_${key}`, value)
        this.setBrowserParams()
    }

    _appendParam(key, value) {
        this.params.append(`${this.prefix}_${key}`, value)
    }

    _deleteParam(key) {
        this.params.delete(`${this.prefix}_${key}`)
        this.setBrowserParams()
    }

    _get(key) {
        return this.params.get(`${this.prefix}_${key}`)
    }

    _getAll(key) {
        return this.params.getAll(`${this.prefix}_${key}`)
    }

    setFilterParam(key, value) {
        let cParams = this._getAll(key)

        const strValue = value.toString()
        if (cParams.includes(strValue)) {
            this._deleteParam(key)

            cParams = cParams.filter((p => p !== strValue))
            cParams.forEach((cValue) => {
                this._appendParam(key, cValue)
            })

            this.setBrowserParams()
            return
        }

        if (value) {
            this._appendParam(key, value)
            this.setBrowserParams()
            return
        }
        this._deleteParam(key)
    }

    setQueryParam(query) {
        if (query) {
            this._setParam(NORSE_FILTERS.QUERY, query)
            return
        }
        this._deleteParam(NORSE_FILTERS.QUERY)
    }

    setDateParam(field, date) {
        if (date) {
            this._setParam(`${field}_${NORSE_FILTERS.DATE}`, date)
            return
        }
        this._deleteParam(`${field}_${NORSE_FILTERS.DATE}`)
    }

    setToDateParam(field, date) {
        if (date) {
            this._setParam(`${field}_${NORSE_FILTERS.TO}`, date)
            return
        }
        this._deleteParam(`${field}_${NORSE_FILTERS.TO}`)
    }

    setFromDateParam(field, date) {
        if (date) {
            this._setParam(`${field}_${NORSE_FILTERS.FROM}`, date)
            return
        }
        this._deleteParam(`${field}_${NORSE_FILTERS.FROM}`)
    }

    setOrderParam(order) {
        let currentOrder = this.getOrderParam()

        if (currentOrder === order) {
            this._deleteParam(NORSE_FILTERS.ORDER)
            return
        }

        if (order) {
            this._setParam(NORSE_FILTERS.ORDER, order)
            return
        }
        this._deleteParam(NORSE_FILTERS.ORDER)
    }

    setPageParam(page) {
        if (page >= 1) {
            this._setParam(NORSE_FILTERS.PAGE, page)
            return
        }
        console.error('Page number should be greater than 0')
        this._setParam(NORSE_FILTERS.PAGE, 1)
    }

    setTabParam(tab) {
        if (tab >= 1) {
            this._setParam(NORSE_FILTERS.TAB, tab)
            return
        }
        console.error('Tab number should be greater than 0')
        this._setParam(NORSE_FILTERS.TAB, 1)
    }

    setChecklistParam(id, dict) {
        if (dict !== undefined) {
            this._setParam(id, dict)
            return
        }

        this._deleteParam(id)
    }

    setBrowserParams() {
        pHandler.setBrowserParams(this.prefix)
        this.useStorage && sessionStorage.setItem('urlParams_' + window.location.pathname, window.location.search)
    }

    getURL() {
        return this.params.toString()
    }

    getFilterParam(key) {
        return this._get(key)
    }

    getAllFilterParams(key) {
        return this._getAll(key)
    }

    getChecklistParam(id) {
        return this._get(id)
    }

    setCustomParam(key, value) {
        this._setParam(key, value)
    }

    getCustomParam(key) {
        return this._get(key)
    }

    getQueryParam() {
        return this._get(NORSE_FILTERS.QUERY)
    }

    getDateParam(field) {
        return this._get(`${field}_${NORSE_FILTERS.DATE}`)
    }

    getToDateParam(field) {
        return this._get(`${field}_${NORSE_FILTERS.TO}`)
    }

    getFromDateParam(field) {
        return this._get(`${field}_${NORSE_FILTERS.FROM}`)
    }

    getOrderParam() {
        return this._get(NORSE_FILTERS.ORDER)
    }

    getTabParam() {
        let tab = this._get(NORSE_FILTERS.TAB)
        return tab ? parseInt(tab, 10) : null
    }

    getPageParam() {
        let page = this._get(NORSE_FILTERS.PAGE)
        return page ? parseInt(page, 10) : null
    }

    setBrowserParams() {
        pHandler.setBrowserParams(this.prefix)
        this.useStorage && sessionStorage.setItem('urlParams_' + window.location.pathname, window.location.search)
    }

    clearParams() {
        pHandler.updateState(' ')
    }

    getBuilderURL() {
        return this.params.toString()
    }

    getBrowserParamsDict() {
        let localKeys = []
        for (let key of this.params.keys()) {
            if (key.includes(this.prefix)) {
                localKeys.push(key)
            }
        }

        let paramObj = {}
        for (let [key, value] of this.params.entries()) {
            if (!localKeys.includes(key)) {
                continue
            }
            const values = this.params.getAll(key)
            // Local key would be the key seen in the url prefix_key; i.e. all_cases_table_page
            //In order to easier maintain
            let localKey = key.split(`${this.prefix}_`)[1] || key
            if (values?.length > 1) {
                paramObj[localKey] = values
                continue
            }
            paramObj[localKey] = value
        }
        return paramObj
    }

    isAscending() {
        return this._get(NORSE_FILTERS.ORDER)?.charAt(0) === '-'
    }

    extractUrlParamsFromSessionStorage() {
        let paramsObject = {}
        const item = sessionStorage.getItem('urlParams_' + window.location.pathname)
        if (item) {
            paramsObject[window.location.pathname] = item
        }

        return paramsObject
    }
}


class BREAKPOINTS {
}

BREAKPOINTS.TABLET = 1024
BREAKPOINTS.MOBILE = 670

class DEVICE {
}

DEVICE.DESKTOP = 'DESKTOP'
DEVICE.TABLET = 'TABLET'
DEVICE.MOBILE = 'MOBILE'


const FIELD_INPUT_CHOICES = {
    TEXT_INPUT: 1,
    FILE_INPUT: 2,
    FILE_INPUT_MULTIPLE: 5,
    RADIO_INPUT: 3,
    CHOICE_INPUT: 4,
}


class NorseBreakpoint {

    constructor() {
        this.currentDevice = DEVICE.DESKTOP
        this.resizeObserver = null
    }

    getCurrentDevice() {
        return this.currentDevice
    }

    initResizeObserver(HtmlElement) {
        this.resizeObserver = new ResizeObserver((entries) => {
            entries.forEach((entry) => {
                const treeWidth = entry.contentRect.width
                let newDevice = DEVICE.DESKTOP

                //ToDO; find a nice way to utilize isOverflowing
                const isOverflowing = entry.target.clientWidth < entry.target.scrollWidth

                if (treeWidth <= BREAKPOINTS.TABLET) {
                    newDevice = DEVICE.TABLET
                }

                if (treeWidth <= BREAKPOINTS.MOBILE) {
                    newDevice = DEVICE.MOBILE
                }

                if (newDevice !== this.currentDevice) {
                    this.currentDevice = newDevice
                }
            })
        })

        this.resizeObserver.observe(HtmlElement)
    }
}

class NorseVue {
    constructor(options = {}) {
        this.data = options.data || {}
        this.components = options.components || {}
        this.computed = options.computed || {}
        this.methods = options.methods || {}
        this.directives = options.directives || {}
        this.watch = options.watch || {}

        this.beforeCreate = options.beforeCreate || function () {
        }
        this.created = options.created || function () {
        }
        this.mounted = options.mounted || function () {
        }
        this.unmounted = options.unmounted || function () {
        }

        this.provide = options.provide || function () {
            return []
        }
    }

    extend(options) {
        Object.assign(this.data, options.data || {})
        Object.assign(this.components, options.components || {})
        Object.assign(this.computed, options.computed || {})
        Object.assign(this.methods, options.methods || {})
        Object.assign(this.directives, options.directives || {})
        Object.assign(this.watch, options.watch || {})

        //  provide() returns an OBJECT of {name: computed} (see the
        // page controllers and provider() below, which reads its
        // keys). Merge as objects — array spread here breaks every
        // page that actually provides something.
        const baseProvide = this.provide
        this.provide = function () {
            const provided = baseProvide.call(this)
            if (!options.provide) return provided
            return {...provided, ...options.provide.call(this)}
        }

        let beforeCreateFunc = this.beforeCreate
        this.beforeCreate = function () {
            beforeCreateFunc.call(this)
            options.beforeCreate && options.beforeCreate.call(this)
        }
        let createdFunc = this.created
        this.created = function () {
            createdFunc.call(this)
            options.created && options.created.call(this)
        }
        let mountedFunc = this.mounted
        this.mounted = function () {
            mountedFunc.call(this)
            options.mounted && options.mounted.call(this)
        }
        let unmountedFunc = this.unmounted
        this.unmounted = function () {
            unmountedFunc.call(this)
            options.unmounted && options.unmounted.call(this)
        }
    }

    /*
    `provide()` must be defined as a method which returns
    list of variable names declared in the `data` option.
    */

    /*
      baseVue: Array,
      baseProvided: Array,
  */
    provider(baseVue, baseProvided) {
        let pageControllerProvided = this.provide() //returns object
        let pcKeys = Object.keys(pageControllerProvided)
        let variable_list = baseProvided

        if (pcKeys?.length > 0) {
            variable_list = variable_list.concat(pcKeys)
        }

        let provided = {}
        for (let i = 0; i < variable_list.length; ++i) {
            let variable_name = variable_list[i]
            provided[variable_name] = Vue.computed(() => baseVue[variable_name])
        }
        return provided
    }
}

let norseVue = new NorseVue()

const CP_RESULT_STATES = {
    NOT_SET: 1,
    OK: 2,
    NOT_OK: 3,
    CORRECTED: 4,
    CORRECTED_OK: 5,
    NOT_APPLICABLE: 6
}

const SHOW_SECTION = {
    HIDDEN: 'hidden',
    INSTRUCTION: 'instruction',
    REJECTION: 'rejection',
    COMMENT: 'comment'
}

class SeverityValue {
    constructor(data) {
        this.pk = data.pk
        this.name = data.name
        this.shortName = data.short_name
        this.description = data.description
        this.level = data.level
        this.sortWeight = data.sort_weight
    }

    get isRejectionValue() {
        return this.level !== SeverityValue.LEVEL_OK
    }

    static asItems(json) {
        return json.map(jsonItem => {
            return new SeverityValue(jsonItem)
        })
    }
}

SeverityValue.LEVEL_OK = 1

class ChecklistResult {
    constructor(data) {
        this.pk = data.pk
        this.state = data.state
    }
}

class NorseCard {
    constructor(data, level) {
        this.pk = data.pk
        this.level = level ? level + 1 : 1
        this.kind = data.kind || ''
        this.active = data.active || false
        this.cards = data.cards ? NorseCard.asItems(data.cards, this.level) : []
        this.showSection = SHOW_SECTION.HIDDEN
    }

    get refId() {
        return `${this.level}-${this.kind}-${this.pk}`
    }

    get isControlPoint() {
        return this.isKind(KINDS.CONTROL_POINT)
    }

    get isGroup() {
        return this.isKind(KINDS.GROUP)
    }

    get isBuilding() {
        return this.isKind(KINDS.BUILDING)
    }

    get isSystem() {
        return this.isKind(KINDS.SYSTEM)
    }

    get isAirFlow() {
        return this.isKind(KINDS.AIR_FLOW)
    }

    get showInstruction() {
        return this.isSection(SHOW_SECTION.INSTRUCTION)
    }

    get showRejection() {
        return this.isSection(SHOW_SECTION.REJECTION)
    }

    get showComment() {
        return this.isSection(SHOW_SECTION.COMMENT)
    }

    get childsCount() {
        return this.cards.length
    }

    static getCardsForLevel(cards, level) {
        if (!cards || !cards.length) {
            return []
        }

        let isLevel = cards.some(card => card.level === level)
        if (isLevel) {
            return cards
        }
        let activeCard = cards.find(card => card.active)
        cards = activeCard ? activeCard.cards : []
        return NorseCard.getCardsForLevel(cards, level)
    }

    // sets property active to false for all cards in a certain level
    static resetCardsForLevel(cards, level) {
        let levelCards = NorseCard.getCardsForLevel(cards, level)
        for (let card of levelCards) {
            card.active = false
        }
    }

    // sets property active to false for all cards (children, grandchildren, etc.) of a certain card
    resetCardChildren() {
        if (!this.cards.length) {
            return
        }
        for (let card of this.cards) {
            card.active = false
            card.resetCardChildren()
        }
    }

    /*****************************************
     * Section action
     ****************************************/
    setShowSection(value) {
        if (!Object.values(SHOW_SECTION).includes(value)) {
            throw `Section with value ${value} is not defined.`
        }

        this.showSection = value
    }

    toggleSection(section) {
        if (this.showSection === section) {
            section = SHOW_SECTION.HIDDEN
        }

        this.setShowSection(section)
        this.rerender++
    }

    toggleInstructionSection() {
        this.toggleSection(SHOW_SECTION.INSTRUCTION)
    }

    toggleRejectionSection() {
        this.toggleSection(SHOW_SECTION.REJECTION)
    }

    toggleCommentSection() {
        this.toggleSection(SHOW_SECTION.COMMENT)
    }

    /*****************************************
     *
     ****************************************/
    isKind(kind) {
        return this.kind === kind
    }

    isSection(section) {
        return this.showSection === section
    }

    static asItems(json, level) {
        return json.map(jsonItem => {
            switch (jsonItem.kind) {
                case KINDS.BUILDING:
                    return new BuildingCard(jsonItem, level)
                case KINDS.SYSTEM:
                    return new SystemCard(jsonItem, level)
                case KINDS.SYSTEM_INSPECTION:
                    return new SystemInspectionCard(jsonItem, level)
                case KINDS.AIR_FLOW:
                    return new AirFlowCard(jsonItem, level)
                default:
                    return new ChecklistCard(jsonItem, level)
            }
        })
    }
}

class ChecklistCard extends NorseCard {
    constructor(data, level) {
        super(data, level)
        this.name = data.name || data.group_label || data.content?.name || ''
        this.numbering = data.numbering || ''
        this.instruction = data.content?.instruction || ''
        this.controlPoints = ChecklistCard.setControlPoints(this.cards, this.pk)
        this.result = new ChecklistResult(data.result || {
            pk: '',
            state: CP_RESULT_STATES.NOT_SET
        })
        this.severityValues = SeverityValue.asItems(data.severity_values || [])
        this.CPComments = JSON.parse(JSON.stringify(Object.values(CP_COMMENTS).slice()))
        this.severityValue = new SeverityValue(data.result?.severity_value || {})
        this.rejectionComment = data.rejection?.text || ''
        this.rejectionFiles = []
        this.image = data.rejection?.image ? data.rejection.image : ''
        this.commentFiles = []
        this.comment = data.comment?.text || ''
        this.commentType = ''
        this.improvementFiles = []
        this.improvement = data.improvement?.text || ''
        this.rerender = 0
        this.showDefaultRejection = this.rejectionComment === ''

        if (this.comment === '' && this.improvement !== '') {
            this.CPComments.forEach(value => {
                value.selected = !value.selected
            })
        }
    }

    get isApproved() {
        return this.isResultState(CP_RESULT_STATES.OK)
    }

    get isRejected() {
        return this.isResultState(CP_RESULT_STATES.NOT_OK)
    }

    get isNotSet() {
        return this.isResultState(CP_RESULT_STATES.NOT_SET)
    }

    get isNotApplicable() {
        return this.isResultState(CP_RESULT_STATES.NOT_APPLICABLE)
    }

    get isCommented() {
        return !!this.comment || !!this.improvement
    }

    get controlPointsCount() {
        return this.controlPoints.length
    }

    get controlPointsApprovedCount() {
        return this.controlPoints.filter(p => p.isApproved).length
    }

    get controlPointsRejectedCount() {
        return this.controlPoints.filter(p => p.isRejected).length
    }

    get controlPointsHandledCount() {
        return this.controlPointsApprovedCount + this.controlPointsRejectedCount
    }

    get selectedSeverityValue() {
        let selected = this.severityValues.find(val => val.selected)
        return selected && selected.level
    }

    get selectedCommentImprovement() {
        let selected = this.CPComments.find(val => val.selected)
        return selected.id === CP_COMMENTS.Improvement.id
    }

    get rejectionValues() {
        return this.severityValues.filter(_value => {
            return _value.isRejectionValue
        })
    }

    get approvalValues() {
        return this.severityValues.filter(_value => {
            return !_value.isRejectionValue
        })
    }

    get commentValues() {
        return this.CPComments
    }

    static setControlPoints(cards) {
        return ChecklistCard.getControlPointsForCard({cards: cards})
    }

    static getControlPointsForCard(card) {
        let cpoints = []
        for (let child of card.cards) {
            if (child.isControlPoint) {
                cpoints.push(child)
            } else {
                cpoints = cpoints.concat(ChecklistCard.getControlPointsForCard(child))
            }
        }
        return cpoints
    }

    closeDefaultRejection(_comment = null) {
        if (_comment) {
            this.rejectionComment = _comment.text
        }
        this.showDefaultRejection = false
    }

    openDefaultReject() {
        this.showDefaultRejection = true
    }

    setResultState(state) {
        if (!Object.values(CP_RESULT_STATES).includes(state)) {
            throw `State ${state} is not defined.`
        }

        this.result.state = state
    }

    setResultOK() {
        this.result.state = CP_RESULT_STATES.OK
    }

    setResultNotOK() {
        this.result.state = CP_RESULT_STATES.NOT_OK
    }

    setResultNotSet() {
        this.result.state = CP_RESULT_STATES.NOT_SET
    }

    /*****************************************
     * State action
     ****************************************/
    toggleState(state) {
        if (this.result.state === state) {
            state = CP_RESULT_STATES.NOT_SET
        }

        this.setResultState(state)
    }

    toggleApproval() {
        this.toggleState(CP_RESULT_STATES.OK)
        this.toggleSection(SHOW_SECTION.HIDDEN)
    }

    toggleRejection() {
        this.toggleState(CP_RESULT_STATES.NOT_OK)
        this.toggleSection(SHOW_SECTION.HIDDEN)
    }

    toggleNotApplicable() {
        this.toggleState(CP_RESULT_STATES.NOT_APPLICABLE)
        this.toggleSection(SHOW_SECTION.HIDDEN)
    }

    isResultState(state) {
        return this.result.state === state
    }
}

class DISTRIBUTION_TYPES {

}

DISTRIBUTION_TYPES.PAPER = '1'
DISTRIBUTION_TYPES.EMAIL = '2'
DISTRIBUTION_TYPES.EDI = '3'

const FIELD_CONTROL_POINT_RESULT = {
    NOT_SET: 1,
    APPROVED: 2,
    REJECTED: 3,
    RESOLVED: 4
}
const MAPBOX_AUTOFILL_FIELDS = {
    postalCode: 'postal_code',
    postalCity: 'postal_city'
}

//  Keep in sync with the backend GEOLOCATION_COUNTRIES setting (settings/
// base.py). The autocomplete + route-planner search must offer the same
// countries the server can actually geocode, or a picked address fails to
// resolve on save.
const MAPBOX_GEOLOCATION_COUNTRIES = [
    'NO', 'SE'
]

const PLANNER_IMPORT_TAB_CHOICES = {
    ECAL: 1,
    HISTORY: 2,
}

const IMPORT_JOB_STATES = {
    PENDING: 'PENDING',
    RUNNING: 'RUNNING',
    SUCCESS: 'SUCCESS',
    PARTIAL: 'PARTIAL',
    FAILED: 'FAILED',
}

const IMPORT_JOB_POLL_INTERVAL_MS = 3000

const PLANNER_FACILITY_TAB_CHOICES = {
    FACILITIES: 2,
    POINT_OF_INTERESTS: 3,
    CUSTOMERS: 1,
}
const INSPECTOR_DASHBOARD_TAB_CHOICES = {
    WORK_ORDERS: 1,
    CALENDAR: 2,
}

const INSPECTOR_WORK_ORDERS_TAB_CHOICES = {
    // Mirrors `InspectorWorkOrdersTabs` on the backend.
    MY_WORK_ORDERS: 1,
    ALL_WORK_ORDERS: 2,
}

const PLANNER_DASHBOARD_TAB_CHOICES = {
    // Mirrors `PlannerDashboardTabs` on the backend. Value 2 is the
    // pending-approval routes tab (reused from the old proposed-routes
    // tab) and value 3 (the old calendar tab) is retired; the enum
    // stays non-contiguous by design.
    WORK_ORDERS: 1,
    PENDING_APPROVAL_ROUTES: 2,
    STATISTICS: 4,
}

const ECAL_ICON = 0
const FACILITY_MARKER = 1

class ICON_STATE {
}

ICON_STATE.PARTIALLY = 'partially'
ICON_STATE.FULLY = 'fully'
ICON_STATE.DISABLED = 'disabled'
ICON_STATE.UNPLANNED = 'unplanned'

SELECTED = 0
UN_SELECTED = 1


ECAL_MARKER = {
    url: '/static/img/map_images/unplanned_ecal.png',
    name: 'ECAL'
}

SERMI_MARKER = {
    url: '/static/img/map_images/unplanned_sermi.png',
    name: 'SERMI'
}

ECAL_MARKER_PARTIALLY_SELECTED = {
    url: '/static/img/map_images/partially_ecal.png',
    name: 'partially'
}

ECAL_MARKER_PARTIALLY_UNSELECTED = {
    url: '/static/img/map_images/unselected_partially_ecal.png',
    name: 'unselected_partially'
}

ECAL_MARKER_FULLY_SELECTED = {
    url: '/static/img/map_images/fully_ecal.png',
    name: 'fully'
}

ECAL_MARKER_FULLY_UNSELECTED = {
    url: '/static/img/map_images/unselected_fully_ecal.png',
    name: 'unselected_fully'
}

ECAL_MARKER_UNPLANNED_SELECTED = {
    url: '/static/img/map_images/unplanned_ecal.png',
    name: 'unplanned'
}

ECAL_MARKER_UNPLANNED_UNSELECTED = {
    url: '/static/img/map_images/unselected_marker_ecal.png',
    name: 'unselected_unplanned'
}

ECAL_MARKER_DISABLED = {
    url: '/static/img/map_images/unselectedMarkerecals.png',
    name: 'disabled'
}

FACILITY_MARKER_UNSET = {
    url: '/static/img/map_images/facility_icon_unset.png',
    name: 'FACILITY_MARKER_UNSET'
}

FACILITY_MARKER_INACTIVE = {
    url: '/static/img/map_images/inactive_facility_marker.png',
    name: 'FACILITY_MARKER_INACTIVE'
}


POINT_OF_INTEREST_TEMP_MARKER = {
    url: '/static/img/map_images/default_poi.png',
    name: 'POINT_OF_INTEREST_TEMP_MARKER_DEFAULT'
}


//  Inspector-home POI marker. MapMarkerImageFactory.registerPoiImages()
// replaces this with the dynamically-generated violet house pin; the
// default_poi.png url is just a PNG fallback so the icon-image name always
// resolves to *something* if the factory fails to run.
POINT_OF_INTEREST_INSPECTOR_MARKER = {
    url: '/static/img/map_images/default_poi.png',
    name: 'POINT_OF_INTEREST_MARKER_INSPECTOR'
}


FACILITY_MARKER_SET = {
    url: '/static/img/map_images/facility_icon_set.png',
    name: 'FACILITY_MARKER_SET'
}

const POINT_OF_INTEREST_MARKERS = [
    POINT_OF_INTEREST_TEMP_MARKER,
    POINT_OF_INTEREST_INSPECTOR_MARKER,
]


const FACILITY_PLAN_STATES = {
    UNPLANNED: 0,
    PARTIALLY: 1,
    FULLY: 2,
}

const POINT_OF_INTEREST_TYPE = {
    DEFAULT: 'default',
    INSPECTOR: 'inspector',
}

const CALENDAR_TYPE = {
    MONTH: 1,
    QUARTER: 2,
}


//CSS Constants
const CALENDAR_FOOTER_HEIGHT = 32

const DATE_RANGE = {
    FROM_DATE: 0,
    TO_DATE: 1,
}


const SERVICE_TYPES = {
    ecal: 'ECAL',
    sermi: 'SERMI',
}
// Presentation metadata per visit type — the FontAwesome kit icon and
// human label shown on marker popups and spiderify labels. Keyed like
// SERVICE_TYPES / ICON_CONFIG, so adding a visit type is one entry.
// Brand colours live in variables.scss ($service-ecal / $service-sermi)
// and are applied via CSS classes (colours-from-variables convention).
const SERVICE_TYPE_META = {
    ecal: {label: 'ECAL', faIcon: 'fa-kit fa-ecal-svg'},
    sermi: {label: 'SERMI', faIcon: 'fa-kit fa-sermi-svg'},
}
const ICON_CONFIG = {
    ecal: {
        base: 'ecal',
        icons: {
            selected: {
                fully: 'fully_ecal.png',
                partially: 'partially_ecal.png',
                unplanned: 'unplanned_ecal.png',
                new: 'selected_marker_ecal_new.png',
            },
            unselected: {
                fully: 'unselected_fully_ecal.png',
                partially: 'unselected_partially_ecal.png',
                unplanned: 'unselected_marker_ecal.png',
                new: 'unselected_marker_ecal_new.png',
            },
            disabled: 'unselectedMarkerecals.png'
        }
    },
    sermi: {
        base: 'sermi',
        icons: {
            selected: {
                fully: 'fully_sermi.png',
                partially: 'partially_sermi.png',
                unplanned: 'unplanned_sermi.png',
                new: 'selected_marker_sermi_new.png',
            },
            unselected: {
                fully: 'unselected_fully_sermi.png',
                partially: 'unselected_partially_sermi.png',
                unplanned: 'unselected_marker_sermi.png',
                new: 'unselected_marker_sermi_new.png',
            },
            disabled: 'unselectedMarkersermi.png'
        }
    }
    // add more stop types easily
}

const ICON_MAP = {}

Object.entries(ICON_CONFIG).forEach(([serviceKey, config]) => {
    ICON_MAP[serviceKey] = {
        selected: {},
        unselected: {},
        disabled: {
            name: `${serviceKey}_marker_disabled`,
            url: `/static/img/map_images/${config.icons.disabled}`
        }
    }

    Object.entries(config.icons.selected).forEach(([state, filename]) => {
        ICON_MAP[serviceKey].selected[state] = {
            name: `${serviceKey}_marker_${state}_selected`,
            url: `/static/img/map_images/${filename}`
        }
    })
    Object.entries(config.icons.unselected).forEach(([state, filename]) => {
        ICON_MAP[serviceKey].unselected[state] = {
            name: `${serviceKey}_marker_${state}_unselected`,
            url: `/static/img/map_images/${filename}`
        }
    })
})

const MAP_MARKERS = [
    ECAL_MARKER_PARTIALLY_SELECTED,
    ECAL_MARKER_PARTIALLY_UNSELECTED,
    ECAL_MARKER_FULLY_SELECTED,
    ECAL_MARKER_FULLY_UNSELECTED,
    ECAL_MARKER_UNPLANNED_SELECTED,
    ECAL_MARKER_UNPLANNED_UNSELECTED,
    ECAL_MARKER_DISABLED,
    FACILITY_MARKER_UNSET,
    FACILITY_MARKER_INACTIVE,
    FACILITY_MARKER_SET,
    ECAL_MARKER,
    SERMI_MARKER,
    ...Object.values(ICON_MAP).flatMap(type =>
        [
            ...Object.values(type.selected),
            ...Object.values(type.unselected),
            type.disabled,
        ]
    )
]

// Teo: This cosnt is defined elsewhere.
// const FACILITY_MARKER_UNSET = {
//     name: 'FACILITY_MARKER_UNSET',
//     url: '/static/img/map_images/facility_icon_unset.png',
// }
// const FACILITY_MARKER_SET = {
//     name: 'FACILITY_MARKER_SET',
//     url: '/static/img/map_images/facility_icon_set.png',
// }

// Teo:  Temporary commenting this as am not sure if its needed as it is.
// Moved its definitions in the same name const above
// const MAP_MARKERS = [
//     FACILITY_MARKER_UNSET,
//     FACILITY_MARKER_SET,
//     ...Object.values(ICON_MAP).flatMap(type =>
//         [
//             ...Object.values(type.selected),
//             ...Object.values(type.unselected),
//             type.disabled,
//         ]
//     )
// ]

const ABSENT_REASONS = {
    VACATION: 1,
    OTHER: 2,
    OFFICE_WORK: 3,
}

const MAPBOX_LAYERS_IDS = {
    POINT_OF_INTEREST: 'poi',
    SERVICE: 'service',
}

const MAPBOX_CENTER = {
    SWEDEN: [18.643501, 60.128161]
}

//  The greyscale Mapbox style used by every map in the app.
// Change it here and all maps follow.
const MAP_STYLE = 'mapbox://styles/mapbox/light-v11'

//  Accent colours for the "A" / "B" route-endpoint markers
// (MapMarkerImageFactory.buildEndpointMarkerEl).
const START_MARKER_COLOR = '#0a84ff'
const END_MARKER_COLOR = '#15c46b'


const FACILITY_ACTIVE_STATES = {
    ACTIVE: 1,
    INACTIVE: 2,
}

const MAPBOX_FILTERS = {
    planState: [],
    service: [],
    activeRegionIds: [],
    query: '',
    isNewFacility: false,
    deadlineDate: {fromDate: null, toDate: null},
}

//  Picking an audit whose deadline sits this many whole months (or
// more) outside the deadline span of the audits already in the route
// trips a confirm dialog — a route mixing wildly different deadlines is
// usually a mistake worth a second look. Shared by the create-route and
// edit-work-order map views and the assigned-work-order audit table.
const DEADLINE_WARNING_MONTHS = 5

// Translated label per FacilityPlanStates value, shared by the route map
// components' filters and facility popups. Looked up at render time: the
// JS catalog loads in the page head.
class FacilityPlanStateLabels {
    static get(planState) {
        const labels = {
            [FACILITY_PLAN_STATES.UNPLANNED]: gettext('Unplanned'),
            [FACILITY_PLAN_STATES.PARTIALLY]: gettext('Partially planned'),
            [FACILITY_PLAN_STATES.FULLY]: gettext('Fully planned'),
        };
        return labels[planState];
    }

    // Filter choices in the shape n-multi-select takes.
    static choices() {
        return Object.values(FACILITY_PLAN_STATES).map((value) => ({
            text: FacilityPlanStateLabels.get(value),
            value,
        }));
    }
}

/**
 * MapMarkerImageFactory
 * =====================
 * Generates the facility marker bitmaps that the v2 map's symbol
 * layers reference, instead of shipping one baked PNG per state.
 *
 * WHY this exists
 * ---------------
 * `mapbox-route-planner-v2` renders facilities as GPU symbol layers.
 * `_iconImageExpr()` picks an icon *name* per
 *   service (ecal|sermi) × plan-state × selected/unselected,
 * and every one of those names used to be a hand-exported PNG in
 * /static/img/map_images/. Adding a new scenario (a star, a warning
 * badge, a new plan state) meant a new Photoshop export.
 *
 * This factory composes each marker from primitives —
 *   teardrop pin + coloured ring + white disc + service icon + badge —
 * rasterizes it once, and registers it with `map.addImage(NAME, ...)`
 * under the SAME names `_iconImageExpr()` already emits. The symbol
 * layers, the icon-image expression, and native clustering are
 * untouched; only the image *source* changes from file to generated
 * bitmap. A new scenario is now a branch in `buildSvg()` / `_badge()`,
 * not a new asset.
 *
 * Colours below are sampled from the legacy PNG atlas (pixel values,
 * not eyeballed). They live here as JS constants because they are
 * canvas paint values — the SCSS $service-* brand colours drive the
 * popup/label chips, not the navy map pin.
 *
 * The class is map-agnostic for everything except `registerAll()`:
 * `buildSvg()` and `rasterize()` work with no map, so the output can
 * be previewed/diffed standalone.
 */
class MapMarkerImageFactory {

    // Pin fill is state-driven (shared by ecal + sermi), matching the
    // legacy atlas. Sampled: unplanned_ecal #2349a1, unselected
    // #96a5b9, disabled (unselectedMarkerecals) #85a4ec.
    static FILL = {
        selected: '#2349a1',
        unselected: '#96a5b9',
        disabled: '#85a4ec',
        // A stop at an inactive facility: the grey of .status-label.sent.
        inactive: '#828282',
    };

    // Appended to the service icon name for a stop at an inactive
    // facility (see FacilityMarker.fromBEData).
    static INACTIVE_ICON_SUFFIX = '_INACTIVE';

    // Plan-state corner badge: a saturated glyph disc on a soft halo,
    // sampled from fully_ecal / partially_ecal.
    static BADGE = {
        fully: { disc: '#67c85d', halo: '#d3f6cf' },     // green check
        partially: { disc: '#ff9c28', halo: '#ffe3c3' }, // orange
    };

    // "New facility" star (top-left), sampled from
    // selected_marker_ecal_new.png.
    static STAR = '#f2c94c';

    // Committed source SVGs — one per service, exported once from the
    // FA kit's uploaded icons. Every marker state is generated from
    // these two files, so a new state never needs a new asset. Reading
    // them is a same-origin fetch (cached), so generation is
    // deterministic and offline — no dependency on the FA webfont
    // being loaded when we rasterize.
    static ICON_SVG_URL = {
        ecal: '/static/img/map_images/marker_icon_ecal.svg',
        sermi: '/static/img/map_images/marker_icon_sermi.svg',
    };

    // ── Points of interest ─────────────────────────────────────────
    // POIs reuse the same pin/disc/raster machinery but with their own
    // pin fill + icon per poi_type. Keyed by the POINT_OF_INTEREST_TYPE
    // value; adding a POI type is one entry in each map here + one
    // source SVG + a branch in StaticDataLayerManager's icon-image
    // expression.
    static POI_FILL = '#219653';  // default (green), fallback fill
    static POI_FILL_BY_TYPE = {
        default: '#219653',   // green
        inspector: '#7C3AED', // violet — inspector home, distinct from all others
    };
    static POI_ICON_SVG_URL = {
        default: '/static/img/map_images/marker_icon_poi_default.svg',
        inspector: '/static/img/map_images/marker_icon_poi_inspector.svg',
    };
    // POIs render the shared 54×74 art at this display pixel ratio so
    // their on-map footprint stays close to the legacy 24×34 PNG
    // (≈27px wide) rather than ballooning to facility-pin size.
    static POI_DISPLAY_PIXEL_RATIO = 4;

    // ── Customer facility markers ──────────────────────────────────
    // The customer-details map renders one pin per facility, keyed by
    // active state instead of service × plan-state. Fills are sampled
    // from the legacy PNGs (facility_icon_set.png /
    // inactive_facility_marker.png) so the generated pins keep the
    // colours planners already associate with active vs inactive.
    static FACILITY_STATE_FILL = {
        set: '#5fbeff',
        inactive: '#e69a97',
        // Sampled from facility_icon_unset.png — the dragged/searched
        // but-not-yet-saved marker on the facility detail maps.
        unset: '#8ca0af',
    };
    static FACILITY_ICON_SVG_URL =
        '/static/img/map_images/marker_icon_facility.svg';

    // One canvas size for every marker so the symbol layer's default
    // center anchor lands identically across states (the legacy PNGs
    // drifted 47–49px wide, nudging the anchor; this fixes that).
    static SIZE = { w: 54, h: 74 };

    // Teardrop pin: round head centred at (27,27), tip at (27,70).
    static PIN_PATH =
        'M27,5 C15.1,5 5.5,14.6 5.5,26.5 C5.5,38 16,53 27,70 ' +
        'C38,53 48.5,38 48.5,26.5 C48.5,14.6 38.9,5 27,5 Z';

    constructor(map = null) {
        this.map = map;
        // serviceKey -> { viewBox, inner } parsed from the committed
        // source SVG.
        this._iconCache = {};
    }

    /**
     * The branded "A" / "B" route-endpoint pin used by every map that
     * shows route start/end markers. Styling lives in create-route.scss
     * (.v2-endpoint-marker), compiled into the global sleipner.css.
     * Returns an inert positioning ROOT (gets mapboxgl.Marker's inline
     * transform and .mapboxgl-marker positioning) wrapping the styled
     * pin — .v2-endpoint-marker's `position: relative` would otherwise
     * override .mapboxgl-marker's positioning (stylesheet-order
     * dependent) and drift the pin off its coordinate. Same root/inner
     * split as the v2 spider markers.
     */
    static buildEndpointMarkerEl(letter, color) {
        const root = document.createElement('div');
        root.style.display = 'inline-block';
        const pin = document.createElement('div');
        pin.className = 'v2-endpoint-marker';
        pin.style.setProperty('--accent', color);
        pin.innerHTML = `
            <span class="v2-endpoint-marker-inner">${letter}</span>
            <span class="v2-endpoint-marker-pin"></span>
        `;
        root.appendChild(pin);
        return root;
    }

    // ── Public API ─────────────────────────────────────────────────

    /**
     * Generate + register every service marker name the v2
     * icon-image expression references. Safe to call once the map
     * style is loaded. Existing images of the same name are replaced.
     */
    async registerAll(pixelRatio = 2) {
        if (!this.map) throw new Error('registerAll needs a map');
        await this.loadServiceIcons();
        const jobs = [];
        Object.keys(this._serviceKeys()).forEach((serviceKey) => {
            ['selected', 'unselected'].forEach((variant) => {
                const fill = MapMarkerImageFactory.FILL[variant];
                jobs.push(this._register(`${serviceKey}_marker_unplanned_${variant}`, serviceKey, fill, null, false, pixelRatio));
                jobs.push(this._register(`${serviceKey}_marker_fully_${variant}`, serviceKey, fill, 'fully', false, pixelRatio));
                jobs.push(this._register(`${serviceKey}_marker_partially_${variant}`, serviceKey, fill, 'partially', false, pixelRatio));
                jobs.push(this._register(`${serviceKey}_marker_new_${variant}`, serviceKey, fill, null, true, pixelRatio));
            });
            jobs.push(this._register(`${serviceKey}_marker_disabled`, serviceKey, MapMarkerImageFactory.FILL.disabled, null, false, pixelRatio));
        });
        await Promise.all(jobs);
    }

    /**
     * Load the committed source SVGs (one per service) and cache each
     * icon's viewBox + inner markup. Deterministic and offline — the
     * FA kit runs in webfont mode (no inline <svg> to scrape), so the
     * marker art comes from local files instead.
     */
    async loadServiceIcons() {
        await Promise.all(Object.entries(MapMarkerImageFactory.ICON_SVG_URL).map(async ([serviceKey, url]) => {
            if (this._iconCache[serviceKey]) return;
            const svg = await this._fetchSvg(url);
            if (svg) this._iconCache[serviceKey] = svg;
        }));
    }

    /**
     * Generate + register the POI marker bitmap(s) under the image
     * names StaticDataLayerManager's icon-image expression references
     * (one per poi_type). Call after that manager's init() so it
     * replaces the PNG it loaded. Existing images are replaced.
     */
    async registerPoiImages(rasterPixelRatio = 2) {
        if (!this.map) throw new Error('registerPoiImages needs a map');
        await this._loadPoiIcons();
        // poi_type value -> the icon-image NAME its static-layer
        // expression uses. Mirrors StaticDataLayerManager.addLayer;
        // resolved at call time so the global constants are loaded.
        const nameByType = {
            [POINT_OF_INTEREST_TYPE.DEFAULT]: POINT_OF_INTEREST_TEMP_MARKER.name,
            [POINT_OF_INTEREST_TYPE.INSPECTOR]: POINT_OF_INTEREST_INSPECTOR_MARKER.name,
        };
        await Promise.all(Object.keys(MapMarkerImageFactory.POI_ICON_SVG_URL).map((typeKey) => {
            const name = nameByType[typeKey];
            if (!name) return Promise.resolve();
            const fill = MapMarkerImageFactory.POI_FILL_BY_TYPE[typeKey]
                || MapMarkerImageFactory.POI_FILL;
            return this._register(
                name, `poi:${typeKey}`, fill,
                null, false, rasterPixelRatio,
                MapMarkerImageFactory.POI_DISPLAY_PIXEL_RATIO,
            );
        }));
    }

    async _loadPoiIcons() {
        await Promise.all(Object.entries(MapMarkerImageFactory.POI_ICON_SVG_URL).map(async ([typeKey, url]) => {
            const key = `poi:${typeKey}`;
            if (this._iconCache[key]) return;
            const svg = await this._fetchSvg(url);
            if (svg) this._iconCache[key] = svg;
        }));
    }

    /**
     * The POI pin as a standalone SVG data URL — for a DOM
     * `mapboxgl.Marker` background on the single-point POI maps
     * (detail / edit / create), so that marker matches the dynamically
     * generated POI markers on the GPU map layers. Map-free: reuses
     * buildSvg + the committed icon SVGs, no addImage. Returns null if
     * the icon can't be loaded (caller falls back to the PNG marker).
     */
    async poiMarkerDataUrl(poiType = POINT_OF_INTEREST_TYPE.DEFAULT) {
        await this._loadPoiIcons();
        const iconKey = `poi:${poiType}`;
        if (!this._iconCache[iconKey]) return null;
        const fill = MapMarkerImageFactory.POI_FILL_BY_TYPE[poiType]
            || MapMarkerImageFactory.POI_FILL;
        const svg = this.buildSvg(iconKey, fill, null, false);
        return this._svgDataUrl(svg);
    }

    /**
     * The facility pin as a standalone SVG data URL — for the DOM
     * `mapboxgl.Marker` on the single-facility maps (facility / stop
     * detail), so that marker matches the generated facility markers
     * on the customer-details map. `variant` is 'set' (blue, saved
     * location) or 'unset' (grey, dragged/searched but not saved).
     * Map-free. Returns null if the icon can't be loaded (caller
     * falls back to the legacy PNG marker).
     */
    async facilityMarkerDataUrl(variant = 'set') {
        await this._loadFacilityIcon();
        if (!this._iconCache['facility']) return null;
        const fill = MapMarkerImageFactory.FACILITY_STATE_FILL[variant]
            || MapMarkerImageFactory.FACILITY_STATE_FILL.set;
        const svg = this.buildSvg('facility', fill, null, false);
        return this._svgDataUrl(svg);
    }

    /**
     * Generate + register the plain per-service pin under the legacy
     * image names ECAL_MARKER.name / SERMI_MARKER.name ('ECAL' /
     * 'SERMI'). The work-order / route detail maps (n-mapbox-route)
     * set each feature's icon to its raw facility_type, so replacing
     * these two names swaps their PNGs for the generated pins without
     * touching the layers. Existing images are replaced.
     */
    async registerServiceTypeImages(pixelRatio = 2) {
        if (!this.map) throw new Error('registerServiceTypeImages needs a map');
        await this.loadServiceIcons();
        // serviceKey -> the icon-image NAME the feature's facility_type
        // resolves to. Resolved at call time so the global constants
        // (sleipner-constants.js) are loaded.
        const nameByService = {
            ecal: ECAL_MARKER.name,
            sermi: SERMI_MARKER.name,
        };
        const fill = MapMarkerImageFactory.FILL;
        const inactiveSuffix = MapMarkerImageFactory.INACTIVE_ICON_SUFFIX;
        await Promise.all(Object.entries(nameByService).flatMap(([serviceKey, name]) => [
            this._register(name, serviceKey, fill.selected, null, false, pixelRatio),
            this._register(name + inactiveSuffix, serviceKey, fill.inactive, null, false, pixelRatio),
        ]));
    }

    /**
     * Generate + register the customer-facility pins under the legacy
     * image names FACILITY_MARKER_SET.name / FACILITY_MARKER_INACTIVE.name
     * used by the customer-details maps (mapbox-route-planner in
     * static-icon mode). Existing images are replaced.
     */
    async registerFacilityStateImages(pixelRatio = 2) {
        if (!this.map) throw new Error('registerFacilityStateImages needs a map');
        await this._loadFacilityIcon();
        // state key -> the icon-image NAME the customer-details page
        // assigns per facility active state. Resolved at call time so
        // the global constants (sleipner-constants.js) are loaded.
        const nameByState = {
            set: FACILITY_MARKER_SET.name,
            inactive: FACILITY_MARKER_INACTIVE.name,
        };
        await Promise.all(Object.entries(nameByState).map(([stateKey, name]) =>
            this._register(
                name, 'facility',
                MapMarkerImageFactory.FACILITY_STATE_FILL[stateKey],
                null, false, pixelRatio,
            )
        ));
    }

    async _loadFacilityIcon() {
        if (this._iconCache['facility']) return;
        const svg = await this._fetchSvg(MapMarkerImageFactory.FACILITY_ICON_SVG_URL);
        if (svg) this._iconCache['facility'] = svg;
    }

    //  encodeURIComponent leaves ( ) raw, but these URLs go into a CSS
    // background-image: url(...) — and the pin's rgba(...) shadow would
    // otherwise close the url() early and break the marker. Encode parens.
    _svgDataUrl(svg) {
        const encoded = encodeURIComponent(svg)
            .replace(/\(/g, '%28')
            .replace(/\)/g, '%29');
        return `data:image/svg+xml;charset=utf-8,${encoded}`;
    }

    /** Compose the full marker SVG string for one state. */
    buildSvg(serviceKey, fillColor, planBadge, isNew) {
        const { w, h } = MapMarkerImageFactory.SIZE;
        const icon = this._iconMarkup(serviceKey, fillColor);
        const badge = this._badgeMarkup(planBadge);
        const star = isNew ? this._starMarkup() : '';
        return [
            `<svg xmlns="http://www.w3.org/2000/svg" width="${w}" height="${h}" viewBox="0 0 ${w} ${h}">`,
            // Soft ground shadow so the pin reads on light map tiles.
            `<ellipse cx="27" cy="70" rx="7" ry="2.4" fill="rgba(20,30,50,0.30)"/>`,
            // Pin body + white disc + service icon.
            `<path d="${MapMarkerImageFactory.PIN_PATH}" fill="${fillColor}"/>`,
            `<circle cx="27" cy="26.5" r="15.5" fill="#ffffff"/>`,
            icon,
            // Corner badges last so they sit on top.
            badge,
            star,
            `</svg>`,
        ].join('');
    }

    /** SVG string -> ImageData at the given pixel ratio. */
    async rasterize(svgString, pixelRatio = 2) {
        const { w, h } = MapMarkerImageFactory.SIZE;
        const img = new Image();
        img.decoding = 'async';
        const url = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgString);
        await new Promise((resolve, reject) => {
            img.onload = resolve;
            img.onerror = reject;
            img.src = url;
        });
        const canvas = document.createElement('canvas');
        canvas.width = Math.round(w * pixelRatio);
        canvas.height = Math.round(h * pixelRatio);
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        return ctx.getImageData(0, 0, canvas.width, canvas.height);
    }

    // ── Internals ──────────────────────────────────────────────────

    _serviceKeys() {
        return (typeof SERVICE_TYPE_META !== 'undefined') ? SERVICE_TYPE_META : {};
    }

    // `rasterPixelRatio` controls bitmap crispness; `displayPixelRatio`
    // is what we hand to addImage and decides the on-map footprint
    // (display size = bitmap / displayPixelRatio). They're equal for
    // facilities; POIs render the same 54×74 art at a higher
    // displayPixelRatio so they stay smaller than facility pins.
    async _register(name, iconKey, fill, planBadge, isNew, rasterPixelRatio, displayPixelRatio = rasterPixelRatio) {
        // No source icon → leave the legacy PNG in place rather than
        // registering a glyph-less pin.
        if (!this._iconCache[iconKey]) return;
        const svg = this.buildSvg(iconKey, fill, planBadge, isNew);
        const imageData = await this.rasterize(svg, rasterPixelRatio);
        const payload = {
            width: imageData.width,
            height: imageData.height,
            data: new Uint8Array(imageData.data),
        };
        if (this.map.hasImage(name)) this.map.removeImage(name);
        this.map.addImage(name, payload, { pixelRatio: displayPixelRatio });
    }

    // Nest the source icon, scaled into a ~21px box centred on the
    // disc and re-coloured to the pin fill. Baked fills on the source
    // art are stripped (except fill="none", which keeps stroke-only
    // paths hollow) so the wrapping <g fill> tints the whole glyph to
    // navy/grey like the legacy PNGs.
    _iconMarkup(serviceKey, color) {
        const icon = this._iconCache[serviceKey];
        if (!icon) return '';
        const box = 21;
        const x = 27 - box / 2;
        const y = 26.5 - box / 2;
        const inner = icon.inner
            .replace(/fill\s*=\s*"(?!none\b)[^"]*"/gi, '')
            .replace(/currentColor/gi, color);
        return [
            `<svg x="${x}" y="${y}" width="${box}" height="${box}" viewBox="${icon.viewBox}">`,
            `<g fill="${color}">${inner}</g>`,
            `</svg>`,
        ].join('');
    }

    // Top-right plan-state badge. Each state has its own shape, so we
    // dispatch rather than parameterise one circle: fully = green
    // check disc, partially = orange warning triangle (matching the
    // legacy fully_*/partially_* PNGs).
    _badgeMarkup(kind) {
        const builder = {
            fully: () => this._checkBadge(),
            partially: () => this._warningBadge(),
        }[kind];
        return builder ? builder() : '';
    }

    _checkBadge() {
        const cx = 42;
        const cy = 13;
        const palette = MapMarkerImageFactory.BADGE.fully;
        return [
            `<circle cx="${cx}" cy="${cy}" r="10" fill="${palette.halo}"/>`,
            `<circle cx="${cx}" cy="${cy}" r="8" fill="${palette.disc}" stroke="#ffffff" stroke-width="1.5"/>`,
            `<path d="M${cx - 4},${cy} l3,3 l5,-6" fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>`,
        ].join('');
    }

    _warningBadge() {
        const cx = 42;
        const cy = 13;
        const r = 9;
        const palette = MapMarkerImageFactory.BADGE.partially;
        const apex = `${cx},${cy - r}`;
        const right = `${cx + r * 0.95},${cy + r * 0.72}`;
        const left = `${cx - r * 0.95},${cy + r * 0.72}`;
        return [
            `<polygon points="${apex} ${right} ${left}" fill="${palette.disc}" stroke="#ffffff" stroke-width="1.6" stroke-linejoin="round"/>`,
            `<rect x="${cx - 0.9}" y="${cy - 3.4}" width="1.8" height="4.8" rx="0.9" fill="#ffffff"/>`,
            `<circle cx="${cx}" cy="${cy + 4}" r="1.1" fill="#ffffff"/>`,
        ].join('');
    }

    _starMarkup() {
        const cx = 12;
        const cy = 12;
        const r = 8;
        const points = this._starPoints(cx, cy, r, r * 0.45);
        return [
            `<circle cx="${cx}" cy="${cy}" r="10" fill="#ffffff"/>`,
            `<polygon points="${points}" fill="${MapMarkerImageFactory.STAR}" stroke="#e0a800" stroke-width="0.5"/>`,
        ].join('');
    }

    _starPoints(cx, cy, outer, inner) {
        const pts = [];
        for (let i = 0; i < 10; i++) {
            const radius = (i % 2 === 0) ? outer : inner;
            const angle = (Math.PI / 5) * i - Math.PI / 2;
            pts.push(`${(cx + radius * Math.cos(angle)).toFixed(2)},${(cy + radius * Math.sin(angle)).toFixed(2)}`);
        }
        return pts.join(' ');
    }

    // Fetch a committed source SVG and pull out its viewBox + inner
    // markup. Returns null (with a warning) if the file is missing, so
    // the component can fall back to the legacy PNG for that name.
    async _fetchSvg(url) {
        const response = await fetch(url);
        if (!response.ok) {
            console.warn(`[marker-factory] icon not found: ${url} (${response.status})`);
            return null;
        }
        const text = await response.text();
        const doc = new DOMParser().parseFromString(text, 'image/svg+xml');
        const svg = doc.querySelector('svg');
        if (!svg || doc.querySelector('parsererror')) {
            console.warn(`[marker-factory] icon is not valid SVG: ${url}`);
            return null;
        }
        return {
            viewBox: svg.getAttribute('viewBox') || '0 0 512 512',
            inner: svg.innerHTML,
        };
    }
}

/**
 * TripMarkerFactory
 * =================
 * DOM marker elements for the inspector trip planner, speaking the
 * same visual language as the rest of Sleipner's maps: a teardrop
 * pin with a white disc holding a tinted glyph, plus the A-style
 * endpoint pin for the start point.
 *
 * Every builder returns an inert positioning ROOT (which receives
 * mapboxgl.Marker's inline transform) wrapping the styled pin — a
 * CSS transform on the root itself would override Mapbox's
 * positioning and drift the marker off its coordinate. Pins are
 * anchored at their tip: pass {anchor: 'bottom'} to the Marker.
 *
 * Colours are SVG paint values sampled from variables.scss, kept
 * here as JS constants for the same reason MapMarkerImageFactory
 * keeps its fills in JS.
 */
class TripMarkerFactory {

    // Sleipner's teardrop: round head centred at (27,27), tip (27,70).
    static PIN_VIEWBOX = '0 0 54 74'
    static PIN_PATH =
        'M27,5 C15.1,5 5.5,14.6 5.5,26.5 C5.5,38 16,53 27,70 ' +
        'C38,53 48.5,38 48.5,26.5 C48.5,14.6 38.9,5 27,5 Z'

    static OVERNIGHT_FILL = '#1c2a3d'   // $primary-dark
    static HOTEL_FILL = '#7c3aed'       // $poi-hotel
    static RESTAURANT_FILL = '#f0a020'  // $service-sermi

    // Stroke icons (lucide outlines), tinted to the pin fill.
    static GLYPH_BED = [
        '<path d="M2 4v16"/>',
        '<path d="M2 8h18a2 2 0 0 1 2 2v10"/>',
        '<path d="M2 17h20"/>',
        '<path d="M6 8v9"/>',
    ].join('')
    static GLYPH_MOON =
        '<path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z"/>'
    static GLYPH_UTENSILS = [
        '<path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2"/>',
        '<path d="M7 2v20"/>',
        '<path d="M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Z"/>',
        '<path d="M21 15v7"/>',
    ].join('')

    // Stacking order for overlapping markers: suggestions sit
    // under the trip's own pins, and the sleepover pin always
    // fronts the hotel pins clustered around it.
    static Z_POI = 2
    static Z_STOP = 3
    static Z_OVERNIGHT = 4
    static Z_START = 5

    static WARNING_FILL = '#fabe78'   // $pending

    /** Numbered visit-stop pin in the day's colour. */
    static stopPin(number, color) {
        const disc = TripMarkerFactory._numberMarkup(number, color)
        return TripMarkerFactory._pinRoot(
            'trip-pin-stop', color, disc, 34, 46,
            TripMarkerFactory.Z_STOP)
    }

    /** Numbered stop pin carrying a warning badge — the
     * facility's location is unverified, so the pin may sit a
     * little off the real place. */
    static stopPinUncertain(number, color) {
        const disc =
            TripMarkerFactory._numberMarkup(number, color)
            + TripMarkerFactory._warningBadgeMarkup()
        return TripMarkerFactory._pinRoot(
            'trip-pin-stop trip-pin-uncertain', color, disc,
            34, 46, TripMarkerFactory.Z_STOP)
    }

    static _warningBadgeMarkup() {
        const fill = TripMarkerFactory.WARNING_FILL
        return [
            `<circle cx="45" cy="9" r="8.5" fill="${fill}"`,
            ' stroke="#ffffff" stroke-width="2"/>',
            '<text x="45" y="13" text-anchor="middle"',
            ' font-family="Lato, sans-serif" font-size="12"',
            ' font-weight="900" fill="#1c2a3d">!</text>',
        ].join('')
    }

    /** The prominent dark "sleepover" pin closing a day. */
    static overnightPin() {
        const fill = TripMarkerFactory.OVERNIGHT_FILL
        const glyph = TripMarkerFactory._glyphMarkup(
            TripMarkerFactory.GLYPH_MOON, fill)
        return TripMarkerFactory._pinRoot(
            'trip-pin-overnight', fill, glyph, 42, 56,
            TripMarkerFactory.Z_OVERNIGHT)
    }

    /** Hotel suggestion pin (violet, bed glyph). */
    static hotelPin() {
        const fill = TripMarkerFactory.HOTEL_FILL
        const glyph = TripMarkerFactory._glyphMarkup(
            TripMarkerFactory.GLYPH_BED, fill)
        return TripMarkerFactory._pinRoot(
            'trip-pin-hotel', fill, glyph, 27, 37,
            TripMarkerFactory.Z_POI)
    }

    /** Restaurant suggestion pin (orange, utensils glyph). */
    static restaurantPin() {
        const fill = TripMarkerFactory.RESTAURANT_FILL
        const glyph = TripMarkerFactory._glyphMarkup(
            TripMarkerFactory.GLYPH_UTENSILS, fill)
        return TripMarkerFactory._pinRoot(
            'trip-pin-restaurant', fill, glyph, 27, 37,
            TripMarkerFactory.Z_POI)
    }

    /** The chosen "Eat here" restaurant — larger and outlined so
     * it stands out from the surrounding suggestions. */
    static restaurantPinSelected() {
        const fill = TripMarkerFactory.RESTAURANT_FILL
        const glyph = TripMarkerFactory._glyphMarkup(
            TripMarkerFactory.GLYPH_UTENSILS, fill)
        return TripMarkerFactory._pinRoot(
            'trip-pin-restaurant trip-pin-selected', fill,
            glyph, 36, 49, TripMarkerFactory.Z_STOP, true)
    }

    /** An unpinned meal break — the restaurant pin as a dashed
     * ghost, so it reads as a meal stop whose place is still
     * open, next to the solid pin of a chosen one. */
    static restaurantPinPlaceholder() {
        const fill = TripMarkerFactory.RESTAURANT_FILL
        const root = document.createElement('div')
        root.style.display = 'inline-block'
        root.style.zIndex = String(TripMarkerFactory.Z_STOP)
        const pin = document.createElement('div')
        pin.className =
            'trip-pin trip-pin-restaurant trip-pin-placeholder'
        pin.innerHTML = [
            '<svg width="36" height="49"',
            ` viewBox="${TripMarkerFactory.PIN_VIEWBOX}"`,
            ' xmlns="http://www.w3.org/2000/svg">',
            '<ellipse cx="27" cy="70" rx="7" ry="2.4"',
            ' fill="rgba(20,30,50,0.30)"/>',
            `<path d="${TripMarkerFactory.PIN_PATH}"`,
            ` fill="#ffffff" stroke="${fill}"`,
            ' stroke-width="3" stroke-dasharray="6 4"',
            ' stroke-linejoin="round"/>',
            TripMarkerFactory._glyphMarkup(
                TripMarkerFactory.GLYPH_UTENSILS, fill),
            '</svg>',
        ].join('')
        root.appendChild(pin)
        return root
    }

    /** Sleipner's A-endpoint pin for the (draggable) start point. */
    static startPin() {
        return TripMarkerFactory._endpointPin('A', '')
    }

    /** The B-endpoint pin for a (draggable) custom trip end. */
    static endPin() {
        return TripMarkerFactory._endpointPin(
            'B', 'trip-endpoint-marker-end')
    }

    static _endpointPin(letter, modifierClass) {
        const root = document.createElement('div')
        root.style.display = 'inline-block'
        root.style.zIndex = String(TripMarkerFactory.Z_START)
        const pin = document.createElement('div')
        pin.className =
            `trip-endpoint-marker ${modifierClass}`.trim()
        pin.innerHTML = [
            '<span class="trip-endpoint-marker-inner">',
            `${letter}</span>`,
            '<span class="trip-endpoint-marker-pin"></span>',
        ].join('')
        root.appendChild(pin)
        return root
    }

    static _pinRoot(className, fill, discContent, width, height,
                    zIndex, outlined = false) {
        const root = document.createElement('div')
        root.style.display = 'inline-block'
        root.style.zIndex = String(zIndex)
        const pin = document.createElement('div')
        pin.className = `trip-pin ${className}`
        // paint-order puts the stroke behind the fill, giving a
        // clean white outline around the teardrop.
        const outline = outlined
            ? ' stroke="#ffffff" stroke-width="5"'
              + ' paint-order="stroke" stroke-linejoin="round"'
            : ''
        pin.innerHTML = [
            `<svg width="${width}" height="${height}"`,
            ` viewBox="${TripMarkerFactory.PIN_VIEWBOX}"`,
            ' xmlns="http://www.w3.org/2000/svg">',
            '<ellipse cx="27" cy="70" rx="7" ry="2.4"',
            ' fill="rgba(20,30,50,0.30)"/>',
            `<path d="${TripMarkerFactory.PIN_PATH}"`,
            ` fill="${fill}"${outline}/>`,
            '<circle cx="27" cy="26.5" r="15.5" fill="#ffffff"/>',
            discContent,
            '</svg>',
        ].join('')
        root.appendChild(pin)
        return root
    }

    static _numberMarkup(number, color) {
        return [
            '<text x="27" y="33" text-anchor="middle"',
            ' font-family="Lato, sans-serif" font-size="19"',
            ` font-weight="700" fill="${color}">`,
            `${number}</text>`,
        ].join('')
    }

    static _glyphMarkup(paths, color) {
        return [
            '<svg x="16" y="15.5" width="22" height="22"',
            ' viewBox="0 0 24 24" fill="none"',
            ` stroke="${color}" stroke-width="2.2"`,
            ' stroke-linecap="round" stroke-linejoin="round">',
            paths,
            '</svg>',
        ].join('')
    }
}

/**
 * TripMapRenderer
 * ===============
 * Read-only rendering of a saved trip-plan itinerary onto an
 * existing Mapbox map: day-coloured route lines (real road
 * geometry via the Directions API, straight lines as fallback),
 * pinned-sleepover moon pins and meal-break markers. Used by the
 * assigned-work-order details page to show the inspector's saved
 * plan next to the stop table.
 *
 * The interactive trip-planner page keeps its own rendering —
 * its markers carry hover cards and actions this read-only
 * overlay deliberately has none of.
 */
class TripMapRenderer {

    // Mirror the planner page's day colours so a day keeps its
    // colour between the two views.
    static DAY_COLORS = [
        '#3887be',
        '#e55e5e',
        '#8a5ec7',
        '#2f9e6e',
        '#d98c21',
        '#3fb1ce',
        '#b04f8c',
    ]

    constructor(map) {
        this.map = map
        this.markers = []
        this.layerIds = []
        this.generation = 0
    }

    dayColor(dayIndex) {
        const colors = TripMapRenderer.DAY_COLORS
        return colors[(dayIndex - 1) % colors.length]
    }

    render(itinerary) {
        this.clear()
        // Bumping the generation invalidates directions fetches
        // still in flight for a previous render.
        this.generation += 1
        for (const day of itinerary.days) {
            this._renderDayMarkers(day)
            this._drawDayLine(itinerary, day)
        }
    }

    clear() {
        for (const marker of this.markers) {
            marker.remove()
        }
        this.markers = []
        for (const layerId of this.layerIds) {
            if (this.map.getLayer(layerId)) {
                this.map.removeLayer(layerId)
            }
            if (this.map.getSource(layerId)) {
                this.map.removeSource(layerId)
            }
        }
        this.layerIds = []
    }

    // No pins for the visits themselves — the host map already
    // shows its own facility markers, and duplicated numbered
    // pins (restarting at 1 per day) only added noise. The
    // overlay contributes what the map lacks: day lines,
    // sleepovers and meal breaks.
    _renderDayMarkers(day) {
        for (const entry of day.stops) {
            if (entry.kind === 'break') {
                this._addBreakMarker(day, entry)
            }
        }
        this._addOvernightMarker(day)
    }

    _addBreakMarker(day, entry) {
        const element = entry.pinned
            ? TripMarkerFactory.restaurantPinSelected()
            : TripMarkerFactory.restaurantPinPlaceholder()
        element.title = `Day ${day.index} · ${entry.label}`
        this._addMarker(element, {anchor: 'bottom'}, [
            entry.longitude, entry.latitude])
    }

    _addOvernightMarker(day) {
        // Only chosen sleepovers land a pin — an automatic
        // overnight at the last visit stays pin-less.
        if (!day.overnight || !day.overnight.pinned) {
            return
        }
        const element = TripMarkerFactory.overnightPin()
        element.title =
            `Day ${day.index} · ${day.overnight.label}`
        this._addMarker(element, {anchor: 'bottom'}, [
            day.overnight.longitude, day.overnight.latitude])
    }

    _addMarker(element, options, lngLat) {
        const marker = new mapboxgl.Marker(
            {element, ...options})
            .setLngLat(lngLat)
            .addTo(this.map)
        this.markers.push(marker)
    }

    _drawDayLine(itinerary, day) {
        const coordinates = this._dayCoordinates(itinerary, day)
        const generation = this.generation
        const layerId =
            `trip-overlay-${generation}-${day.index}`
        this.layerIds.push(layerId)
        const color = this.dayColor(day.index)
        this._fetchDirections(coordinates).then(geometry => {
            this._addLineLayer(
                layerId, geometry, color, generation)
        }).catch(() => {
            this._addLineLayer(layerId, {
                type: 'LineString',
                coordinates: coordinates,
            }, color, generation)
        })
    }

    _dayCoordinates(itinerary, day) {
        const coordinates = [
            this._dayStartCoordinate(itinerary, day)]
        for (const entry of day.stops) {
            // A saved plan can hold a stop whose facility was
            // deactivated: it won't be visited, so the line skips it.
            if (entry.kind === 'visit'
                    && entry.stop.is_excluded_by_facility) {
                continue
            }
            if (entry.kind === 'visit') {
                coordinates.push([
                    entry.stop.longitude, entry.stop.latitude])
                continue
            }
            if (entry.pinned) {
                coordinates.push(
                    [entry.longitude, entry.latitude])
            }
        }
        if (day.overnight) {
            coordinates.push([
                day.overnight.longitude,
                day.overnight.latitude,
            ])
        }
        const isLastDay = day.index === itinerary.days.length
        const finalDestination = itinerary.end
            || (itinerary.return_home ? itinerary.start : null)
        if (isLastDay && finalDestination) {
            coordinates.push([
                finalDestination.longitude,
                finalDestination.latitude,
            ])
        }
        return coordinates
    }

    _dayStartCoordinate(itinerary, day) {
        if (day.start_override) {
            return [
                day.start_override.longitude,
                day.start_override.latitude,
            ]
        }
        if (day.index === 1) {
            return [
                itinerary.start.longitude,
                itinerary.start.latitude,
            ]
        }
        const previousDay = itinerary.days[day.index - 2]
        return [
            previousDay.overnight.longitude,
            previousDay.overnight.latitude,
        ]
    }

    _fetchDirections(coordinates) {
        const path = coordinates
            .map(pair => `${pair[0]},${pair[1]}`)
            .join(';')
        const url = 'https://api.mapbox.com/directions/v5'
            + `/mapbox/driving/${path}`
            + '?geometries=geojson&overview=full'
            + `&access_token=${mapboxgl.accessToken}`
        return fetch(url)
            .then(response => response.json())
            .then(data => {
                if (!data.routes || !data.routes.length) {
                    return Promise.reject('no route')
                }
                return data.routes[0].geometry
            })
    }

    _addLineLayer(layerId, geometry, color, generation) {
        if (generation !== this.generation) {
            return
        }
        if (this.map.getLayer(layerId)) {
            return
        }
        try {
            this._addLineSourceAndLayer(layerId, geometry, color)
        } catch (error) {
            // Style mid-digestion — retry once it settles.
            this.map.once('idle', () => {
                this._addLineLayer(
                    layerId, geometry, color, generation)
            })
        }
    }

    _addLineSourceAndLayer(layerId, geometry, color) {
        if (!this.map.getSource(layerId)) {
            this.map.addSource(layerId, {
                type: 'geojson',
                data: {
                    type: 'Feature',
                    properties: {},
                    geometry: geometry,
                },
            })
        }
        this.map.addLayer({
            id: layerId,
            type: 'line',
            source: layerId,
            layout: {
                'line-join': 'round',
                'line-cap': 'round',
            },
            paint: {
                'line-color': color,
                'line-width': 4,
                'line-opacity': 0.75,
            },
        })
    }
}

